import { Location } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { MatExpansionPanel } from '@angular/material/expansion';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NzModalRef, NzModalService } from 'ng-zorro-antd';
import { PagesLoadedEvent, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { ToastrService } from 'ngx-toastr';
import { ReplaySubject, Subject, Subscription } from 'rxjs';
import { finalize, first, map, takeUntil } from 'rxjs/operators';
import { ContractAttachments } from 'src/app/core/class/contract-attachments';
import { DocumentQuicklyEntity } from 'src/app/core/class/DocumentEntity';
import { Message } from 'src/app/core/class/message';
import { EnumContractEnterpriseStatus, EnumContractUserRole } from 'src/app/core/constants/contract';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { FeatureGroup } from 'src/app/core/constants/permission';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import Utils from 'src/app/core/services/app-utils';
import { AsEnterpriseService } from 'src/app/core/services/as-enterprise.service';
import { AutoEnterpriseService } from 'src/app/core/services/auto-enterprise.service';
import { AutoUserService } from 'src/app/core/services/auto-user.service';
import { CommonService } from 'src/app/core/services/common.service';
import { ContractService } from 'src/app/core/services/contract.service';
import { CreateContractService } from 'src/app/core/services/create-contract.service';
import { DigitalCertificateService } from 'src/app/core/services/digital-certificate.service';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { DocumentService } from 'src/app/core/services/document.service';
import { EnterpriseService } from 'src/app/core/services/enterprise.service';
import FileUtils, { ContentType } from 'src/app/core/services/file-utils';
import { NotificationService } from 'src/app/core/services/notification.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { ProcedureComponent } from 'src/app/shared/components/procedure/procedure.component';
import { WaringSignatureComponent } from 'src/app/shared/components/waring-signature/waring-signature.component';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { DocumentDTO } from 'src/app/shared/models/document-dto.model';
import { SignPosition } from 'src/app/shared/models/sign-position.model';
import * as uuid from 'uuid';
import { AddDocumentGroupV3Component } from '../add-document/general-form-info/add-document-group-v3/add-document-group-v3.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Common } from 'src/app/core/constants/common';
import { WarningSmsContractService } from 'src/app/core/services/warning-sms-contract.service';
import { AlertComponent } from 'src/app/shared/components/alert/alert.component';

@Component({
  selector: 'app-add-document-quickly',
  templateUrl: './add-document-quickly.component.html',
  styleUrls: ['./add-document-quickly.component.scss'],
})
export class AddDocumentQuicklyComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  tabMode: 'hide' | 'info' | 'sign' = 'info';
  activeFile: number = 0;
  fileUploads: File[] = [];
  public pdfSrc: string;
  oldPdfSrc: string;
  mainContractAttachments: ContractAttachments[] = [];
  // Refresh input file
  @ViewChild("inputUpload", { read: "", static: false })
  inputUploadFile: ElementRef;
  @ViewChild("inputUpload1", { read: "", static: false })
  inputUploadFile1: ElementRef;
  // Button upload
  @ViewChild("btnUpload", { read: "", static: false }) btnUpload: ElementRef;
  mesage: string = '';
  maxSize: number = 0
  maxSizeSystem: number = 0;
  maxPerMainFile: number = 0;
  configSizeApprove: number = 0;
  configPageSign: number = 0;
  configNumberPosition: number = 0;
  biggerThan10MBFileSize: number;
  fileUploadSize: number = 0;
  size10MB = 10*1024*1024;
  size150MB = 150*1024*1024;
  size1MB = 1*1024*1024;
  isBuyContract1Mb: boolean = false;
  isBuyContract10Mb: boolean = false;
  isFormChanging: boolean = false;
  zoomLevel = 100;
  totalPage: any;
  pageIndex = 1;
  public listPdfSrc = {};
  fileUploadArray:any[] = [];
  fileUploadSrc:any[] = [];
  document: DocumentQuicklyEntity;
  tplModal: NzModalRef;
  @ViewChild('f', { read: NgForm, static: true }) ngForm: NgForm;
  @ViewChildren(MatExpansionPanel) panels: QueryList<MatExpansionPanel>;
  isShowAddDocument: boolean = false;
  permissions: any;
  serviceTypes: any[] = [];
  isOnAutoNumber = false;
  serviceTypesFilterCtrl: FormControl = new FormControl();
  private onDestroy = new Subject<void>();
  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public mediaBreakpoint: any;
  selectedServiceType: any;
  enterpriseSign: any[] = [];
  defaultEnterprise: any;
  userSigns: any[] = [];
  isShowUserSignTable:boolean = true;
  warningContractQuantity:boolean = false;
  inputUserValue: string;
  inputUserSignValue: string;
  nzCheckLoadingUserSign:boolean = false;
  nzCheckLoadingUser:boolean = false;
  filteredUserOptions = [];
  roleUser = EnumContractUserRole;
  valueSelectedUserRole: string = (this.roleUser.APPROVE + '');
  enterpriseSignId: string = '';
  enumContractEnterpriseStatus = EnumContractEnterpriseStatus;
  valueAddPartyOrder = 2;
  listSign = [];
  widthRectangle = 300;
  heightRectangle = 136;
  widthRectangleSignature = 170;
  heightRectangleSignature = 70;
  isSelectPosition = false;
  signSelected = null;
  documentCodeNull = false;
  configAutoNumber: string;

  signNeedShow: null;
  signApproverNeedShow: null;
  maxPageCurrent;
  isMouseLeave: boolean = false;
  inputPartyValue: string;
  filteredPartyOptions = [];
  timeOutQueryServer = null;
  nzCheckLoadingParty = false;
  private stampWrapper: HTMLDivElement;
  form: FormGroup;
  subscriptions: Subscription = new Subscription();
  authorization: any
  public language: string;
  isHide = false;
  checkFocus = false;
  emailPattern = Common.EMAIL_PATTERN;
  phonePattern2 = Common.PHONE_PATTERN2;
  eventWarningContractSubscription;
  clickSave = false;
  maxLengthPhone = Common.MAX_LENGTH_PHONE;
  constructor(
    private documentService: DocumentService,
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    private breadcrumbsService: BreadcrumbsService,
    public notificationService: NotificationService,
    private toastr: ToastrService,
    public message: Message,
    private route: ActivatedRoute,
    private createContractService: CreateContractService,
    private cdr: ChangeDetectorRef,
    private contractService: ContractService,
    private digitalCertificateService: DigitalCertificateService,
    private modalService: NzModalService,
    private documentTypeService: DocumentTypeService,
    public autoUserService: AutoUserService,
    private enterpriseService: EnterpriseService,
    private translateService: TranslateService,
    public autoEnterpriseService: AutoEnterpriseService,
    private fb: FormBuilder,
    private location: Location,
    private asEnterpriseService: AsEnterpriseService,
    private warningSmsContractService: WarningSmsContractService,
  ) {
    super(commonService, message);
    pdfDefaultOptions.renderInteractiveForms = false;
    this.document = {
      id: '',
      code: '',
      name: '',
      parentId: '',
      enterpriseId: localStorage.getItem('enterpriseId'),
      fileNameUpdate: '',
      customerEnterpriseId: '',
      filePath: '',
      assignUserId: 0,
      submitedTo: 0,
      contractAttachments: [],
      newUploadContractAttachments: [],
      serviceType: null,
      enterpriseSign: [],
      userSign: [],
      signPage: null,
      signPositions: [],
      mainContractAttachments: [],
      fileSizeUpdate: 0,
      dataDocumentParent: [],
      lstReferenceContractId: [],
      contractCodePositions: [],
    }
    this.form = this.fb.group({
      enterprises: this.fb.array([]),
    });
  }
  ngOnDestroy(): void {
    this.createContractService.recordsPartySign.next([]);
    this.createContractService.recordsInternalUsers.next([]);
    this.createContractService.recordsUserPerformSign.next([]);
    this.createContractService.infoFile.next([]);
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit(): void {
  }
  @BlockUI() blockUI: NgBlockUI;

  ngOnInit() {
    this.hideFooter();
    this.authorization = {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    }
    this.language = localStorage.getItem("__language") || "vi";
    this.permissions = JSON.parse(localStorage.getItem('permissions')) || '';
    if (this.permissions.includes(FeatureGroup.MANAGE_ENTERPRISE)) {
      this.isShowAddDocument= true;
    } else {
      this.isShowAddDocument= false;
    }
    this.subscribeData();
    this.getDataCountNumberDocumentOfEnterpriseByService();
    this.getListServiceTypes();
    this.getDefaultEnterprises();
    this.serviceTypesFilterCtrl.valueChanges
    .pipe(takeUntil(this.onDestroy))
    .subscribe(
    () => {
      this.commonService.filterCertificateType(this.serviceTypes, this.serviceTypesFilterCtrl, this.filteredServiceTypes);
    });
    const shouldReuseRouteSub = this.router.routeReuseStrategy.shouldReuseRoute = (future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot) => {

      if (this.isFormChanging) {
        let message = this.message.getMessage('messages.cancel_create_contract_step1');

        const confirmDialog = this.dialog.open(WarningComponent, {
          width: "350px",
          data: message
        });
        confirmDialog.afterClosed().subscribe(res => {
          if (res) {
            this.router.navigateByUrl(window.location.pathname);
          }
        });
      }
      return true;
    };
    this.subscriptions.add(shouldReuseRouteSub);
    if (this.router.url.includes('/home-enterprise/add-contract-quickly')) {
      /**
       * Có thể không dùng QuantitySms đã có khi lấy thông tin document
       * */
      this.warningSmsContractService.getDataQuantityAndWarningQuantitySmsContractOfEnterpriseByService();
      this.eventWarningContractSubscription = this.warningSmsContractService.statusUpdated.subscribe(
        //merge 21511
        (response) => {
          if (response.isBuyContract10Mb && !response.isBuyContract1Mb) {
            if (response.contractQuantity <= 0) {
              this.warningContractQuantity = true;
            }
          } else if (!response.isBuyContract10Mb && response.isBuyContract1Mb) {
            if (response.contract1MbQuantity <= 0) {
              this.warningContractQuantity = true;
            }
          } else if (response.isBuyContract10Mb && response.isBuyContract1Mb) {
            if (response.contract1MbQuantity <= 0 && response.contractQuantity <= 0) {
              this.warningContractQuantity = true;
            }
          } else {
            this.warningContractQuantity = true;
          }
          if (this.warningContractQuantity === true) {
            const dialogRef = this.dialog.open(AlertComponent, {
              width: '370px',
              data: this.message.getMessage('messages.warning_out_of_contract_quantity')
            });
            dialogRef.afterClosed().subscribe(rs => {
              this.router.navigate(['home-enterprise/search-my-created-document']);
            });
          }
        }
      );

      this.subscriptions.add(this.eventWarningContractSubscription);
    }
  }

  subscribeData() {
    this.subscriptions.add(
      this.createContractService.recordsPartySign.asObservable().subscribe(res => {
        if (res.length) {
          this.enterprises.clear();
          this.enterpriseSign = res.filter(e => e.isCreatedSide);
          const customerSigns = res.filter(e => !e.isCreatedSide);
          if (customerSigns.length > 0) {
            customerSigns.forEach(item => {
              const group = this.fb.group({
                order: [item.order],
                certificateNo: [item.certificateNo, [Validators.required, Validators.pattern(this.certificateNoPattern)]],
                name: [item.name, [Validators.required]],
                customerType: [item.customerType == '10000' ? '10000' : '10001', [Validators.required]],
                email: [item.email, [Validators.pattern(this.emailPattern)]],
                phone: [item.phone, [Validators.required, Validators.pattern(this.phonePattern2)]],
                enterpriseId: [item.enterpriseId],
                enterpriseName: [item.enterpriseName],
                customerId: [item.customerId],
                status: [item.status],
                isCreatedSide: [item.isCreatedSide],
                useDataForTemplate: [item.useDataForTemplate],
                isSignNoLogin: [item.isSignNoLogin],
                resize: [item.resize],
                inputPartyValue: [item.inputPartyValue],
                idCustomer: [uuid.v4()],
                isLoading: [false],
              });
              this.enterprises.push(group);
            });
          }
          this.listSign = this.listSign.map(sign => {
            return {
              ...sign,
              isDelete: true
            }
          });
          this.changeDataToTable();
        }
      })
    );

    this.subscriptions.add(
      this.createContractService.recordsUserPerformSign.asObservable().subscribe(res => {
        this.userSigns = res.map(e => {
          let signConfig = e.signConfig;
          if (e.role == '2') {
            signConfig.showImage = false;
          }
          return {
            ...e,
            enterpriseId: e.enterpriseSignId,
            isSignDigitalCertificate: false,
            signConfig: signConfig
          }
        });
        const userSign = this.userSigns.find(user => user.role == '1');
        if (userSign) {
          this.listSign.forEach(sign => {
            if (userSign.enterpriseId === sign.enterpriseSignId) {
              sign.isDelete = true
            }
          })
        }
        this.changeDataToTable();
      })
    );
    this.subscriptions.add(
      this.commonService.getCurrentLanguage().subscribe((lang) => {
        if (lang !== this.language) {
          location.reload();
        }
      })
    );
  }
  canDeactivate() {
    if (this.isFormChanging) {
      let message;
      message = this.message.getMessage('messages.cancel_create_contract_step1');
      const confirmDialog = this.dialog.open(WarningComponent, {
        width: '350px',
        data: message
      });
      return confirmDialog.afterClosed().pipe(map(res => {
        if (res) {
          return true;
        } else {
          return false;
        }
      }), first());
    } else {
      return true;
    }
  }

  get enterprises(): FormArray {
    return this.form.get('enterprises') as FormArray;
  }
  hideFooter() {
    const footer = document.querySelector('app-footer') as HTMLElement;
    if (footer) {
      footer.style.display = 'none';
    }
  }

  setFormChanging() {
    this.isFormChanging = true;
  }

  onClickBtnCancel() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: "350px",
        data: this.message.getMessage("messages.cancel_create_contract_step1"),
      });
      dialogRe.afterClosed().subscribe((rs) => {
        if (rs) {
          this.isFormChanging = false;
          this.location.back();
        }
        dialogRe.close();
      });
    } else {
      this.location.back();
    }
  }
  onClickBtnSave(isDraft: boolean = false) {
    this.clickSave = true;
    this.enterprises.markAllAsTouched();
    this.ngForm.control.markAllAsTouched();
    if (this.enterprises.invalid || this.ngForm.invalid) {
      return;
    }
    if (!this.pdfSrc) {
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.error_contract_quickly'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.error_contract_quickly'));
      }
      const listBtn = document.querySelectorAll("button");
      listBtn.forEach((btn) => {
        if (btn.className.includes('mat-stroked-button-create-document')) {
          btn.classList.add("btn_glowing");
        }
      });
      setTimeout(() => {
        listBtn.forEach((btn) => {
          btn.classList.remove("btn_glowing");
        });
      }, 5000);
      return;
    }
    const dataCustomers = this.enterprises.value;
    if (dataCustomers.length === 0 && this.enterpriseSign.length === 0) {
      this.toastr.error(this.message.getMessage('validation.error_enterprise_no_set_up'));
      return;
    }
    const isUserSign = this.userSigns.find(user => user.role == '1');
    if (!isUserSign && (dataCustomers.length === 0 || this.enterpriseSign.length > 0)) {
      this.toastr.error(this.message.getMessage('validation.error_user_no_set_up'));
      return;
    }



    this.asEnterpriseService.getEnterpriseCheckResources().subscribe((rs) => {
      if (rs && rs.code == 200) {
        const isBuyContract1Mb = rs.data.isBuy1MB;
        const isBuyContract10Mb = rs.data.isBuy10MB;
        const configSizeApprove = this.configSizeApprove;
        const configPageSign = this.configPageSign;
        const configNumberPosition = this.configNumberPosition;
        let signPositions = this.listSign;
        const recordPerformSigns = this.userSigns;
        const customerSigns = this.enterprises.value;
        const recordsPartySign = [
          ...this.enterpriseSign,
          ...customerSigns
        ];
        const fileUploadArray:any = this.fileUploadArray;
        const infoFile = this.createContractService.infoFile.getValue();
        let isMorePosition: boolean = false;
        let isMoreApproveCusAndPosition: boolean = false;
        let isMoreNumberPage: boolean = false;
        let uploadSize = 0;
        const dataUserApproves = recordPerformSigns.filter(user => user.role == '2');
        const userEntSign = recordPerformSigns.filter(user => user.role == '1');
        let listFileIds = fileUploadArray.map(file => file.id);
        const filteredList = signPositions.filter(item => listFileIds.includes(item.fileId));
        for (let i = 0; i < userEntSign.length; i++) {
          const positionOfEnterprises = filteredList.filter(positon => positon.enterpriseId === userEntSign[i].enterpriseId);
          if (positionOfEnterprises.length > configNumberPosition) {
            isMorePosition = true;
            break;
          }
        }
        for (let j = 0; j < recordsPartySign.length; j++) {
          const positionOfEnterprises = filteredList.filter(positon => positon.certificateNo === recordsPartySign[j].certificateNo);
          if (positionOfEnterprises.length > configNumberPosition) {
            isMorePosition = true;
            break;
          }
        }
        // Kiem tra so luong nguoi phe duyet + chan ky cua chu the KHACH HANG
        for (let a = 0; a < recordsPartySign.length; a++) {
          if (!recordsPartySign[a].isCreatedSide) {
            if (recordsPartySign[a].customerApproves) {
              if (recordsPartySign[a].customerApproves.length > configSizeApprove) {
                isMoreApproveCusAndPosition = true;
                break;
              } else {
                for (let b = 0; b < recordsPartySign[a].customerApproves.length; b++) {
                  const positionOfCustomerSign = filteredList.filter(positon => positon.userId === recordsPartySign[a].customerId);
                  const positionOfCustomer = filteredList.filter(positon => positon.userId === recordsPartySign[a].customerApproves[b].userId);
                  if (positionOfCustomer.length + positionOfCustomerSign.length > configNumberPosition) {
                    isMoreApproveCusAndPosition = true;
                    break;
                  }
                }
              }
            }
          }
        }
        for (let index = 0; index < fileUploadArray.length; index++) {
          const fileInfo = infoFile.find(file => file.id === fileUploadArray[index].id);
          if (fileInfo && fileInfo.numberPage > configPageSign) {
            isMoreNumberPage = true;
            break;
          }
        }
        for (let index = 0; index < fileUploadArray.length; index++) {
          uploadSize = uploadSize + fileUploadArray[index].size
        }

        if (isBuyContract10Mb && !isBuyContract1Mb) {
            this.handlePassValidateSave(isDraft);
        } else if (!isBuyContract10Mb && isBuyContract1Mb) {
          if (dataUserApproves.length <= configSizeApprove && !isMorePosition && !isMoreNumberPage && uploadSize <= this.size1MB) {
            this.handlePassValidateSave(isDraft);
          } else {
            this.toastr.error(this.message.getMessage('messages.unable_to_create_1MB_contract'));
            return;
          }
        } else {
          if (dataUserApproves.length <= configSizeApprove && !isMorePosition && !isMoreNumberPage && uploadSize <= this.size1MB) {
            if (rs.data.isQuantity1MB && rs.data.isExpire1MB) {
              this.handlePassValidateSave(isDraft);
            } else {
              if (rs.data.isQuantity10MB && rs.data.isExpire10MB) {
                let message = 'messages.want_to_continue_creating_and_using_the_10MB';
                const dialogRe = this.dialog.open(WarningComponent, {
                  width: '500px',
                  data: this.message.getMessage(message),
                });
                dialogRe.afterClosed().subscribe(rs => {
                  if (rs) {
                    this.handlePassValidateSave(isDraft);
                  }
                });
              } else {
                this.toastr.error(this.message.getMessage('messages.document_resource_has_run_out'));
                return;
              }
            }
          } else {
            this.handlePassValidateSave(isDraft);
          }
        }
      }
    });
  }
  handlePassValidateSave(isSaveDraft: boolean) {
    if (isSaveDraft) {
      if (this.listSign.length === 0) {
        const dialogRe = this.dialog.open(WaringSignatureComponent, {
          width: '500px',
        });
        dialogRe.afterClosed().subscribe(rs => {
          if (rs) {
            this.saveContract(isSaveDraft);
          }
        });
      } else {
        this.saveContract(isSaveDraft);
      }
    } else {
      let message = 'messages.confirm_start_flow';
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '500px',
        data: this.commonService.format(this.message.getMessage(message), this.document.name)
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.saveContract(isSaveDraft);
        }
      });
    }
  }

  // Doanh nghiệp mua Dịch vụ
  getDataCountNumberDocumentOfEnterpriseByService() {
    this.contractService.getDataCountNumberDocumentOfEnterpriseByService().subscribe(
      response => {
        console.log('ENTERPRISE BY SERVICE:', response.data);
        this.biggerThan10MBFileSize = response.data.biggerThan10MBFileSize;
        this.isBuyContract10Mb = response.data.isBuyContract10Mb;
        this.isBuyContract1Mb = response.data.isBuyContract1Mb;
        this.getMaxSize(response.data.biggerThan10MBFileSize);
      }
    );
  }
  getMaxSize(biggerThan10MBFileSize: number){
    const id = localStorage.getItem('enterpriseId')
    this.digitalCertificateService.getPermissionHSM(id).subscribe(res => {
      if(res && res.success){
        this.maxSize = res.data.maxSize > 0 ? res.data.maxSize : this.size10MB;
        this.maxSizeSystem = res.data.maxSizeSystem ? res.data.maxSizeSystem : this.size150MB;
        this.maxPerMainFile = res.data.maxPerMainFile ? res.data.maxPerMainFile : this.size150MB;
        this.configSizeApprove = res.data.approveContractLight;
        this.configPageSign = res.data.pageContractLight;
        this.configNumberPosition = res.data.numberPositionSignContractLight;
        if (!this.isBuyContract10Mb && this.isBuyContract1Mb) {
          this.mesage = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.size1MB / 1024 / 1024)));
        } else {
          this.mesage = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024)));
        }
      }
    })
  }
  public chooseFile() {
    document.getElementById('file').click();
    return;
  }
  convertTitleResource() {
    const isBuyContract1Mb = this.isBuyContract1Mb;
    const isBuyContract10Mb = this.isBuyContract10Mb;
    const configSizeApprove = this.configSizeApprove;
    const configPageSign = this.configPageSign;
    const configNumberPosition = this.configNumberPosition;
    let signPositions = this.listSign;
    const recordPerformSigns = this.userSigns;
    const customerSigns = this.enterprises.value;
    const recordsPartySign = [
      ...this.enterpriseSign,
      ...customerSigns
    ];
    const fileUploadArray:any = this.fileUploadArray;
    const infoFile = this.createContractService.infoFile.getValue();
    if (isBuyContract1Mb && !isBuyContract10Mb) {
      return this.message.getMessage('title.contract_document_1MB');
    } else if (!isBuyContract1Mb && isBuyContract10Mb) {
      return this.message.getMessage('title.contract_document_10MB');
    } else {
      let uploadSize = 0;
      let isMorePosition: boolean = false;
      let isMoreApproveCusAndPosition: boolean = false;
      let isMoreNumberPage: boolean = false;
      const dataUserApproves = recordPerformSigns.filter(user => user.role == '2');
      const userEntSign = recordPerformSigns.filter(user => user.role == '1');
      let listFileIds = fileUploadArray.map(file => file.id);
      const filteredList = signPositions.filter(item => listFileIds.includes(item.fileId));

      //Kiem tra so luong chan ky cua chu the Ben Lap
      for (let i = 0; i < userEntSign.length; i++) {
        const positionOfEnterprises = filteredList.filter(positon => positon.enterpriseId === userEntSign[i].enterpriseId);
        if (positionOfEnterprises.length > configNumberPosition) {
          isMorePosition = true;
          break;
        }
      }
      // Kiem tra so luong nguoi phe duyet + chan ky cua chu the KHACH HANG
      for (let a = 0; a < recordsPartySign.length; a++) {
        if (!recordsPartySign[a].isCreatedSide) {
          if (recordsPartySign[a].customerApproves) {
            if (recordsPartySign[a].customerApproves.length > configSizeApprove) {
              isMoreApproveCusAndPosition = true;
              break;
            } else {
              for (let b = 0; b < recordsPartySign[a].customerApproves.length; b++) {
                const positionOfCustomerSign = filteredList.filter(positon => positon.userId === recordsPartySign[a].customerId);
                const positionOfCustomer = filteredList.filter(positon => positon.userId === recordsPartySign[a].customerApproves[b].userId);
                if (positionOfCustomer.length + positionOfCustomerSign.length > configNumberPosition) {
                  isMoreApproveCusAndPosition = true;
                  break;
                }
              }
            }
          }
        }
      }

      for (let index = 0; index < fileUploadArray.length; index++) {
        const fileInfo = infoFile && infoFile.find(file => file.id === fileUploadArray[index].id);
        if (fileInfo && fileInfo.numberPage > configPageSign) {
          isMoreNumberPage = true;
          break;
        }
      }
      for (let index = 0; index < fileUploadArray.length; index++) {
        uploadSize = uploadSize + fileUploadArray[index].size
      }

      if (dataUserApproves.length <= configSizeApprove && !isMorePosition && !isMoreNumberPage && uploadSize <= this.size1MB && !isMoreApproveCusAndPosition) {
        return this.message.getMessage('title.contract_document_1MB');
      } else {
        return this.message.getMessage('title.contract_document_10MB');
      }
    }
  }
  async onSelectedUpload(e) {
    await this.getFile(e);
    this.reset();
  }
  /**
 *  Refresh input upload file
 */
  private reset() {
    this.inputUploadFile.nativeElement.value = "";
    this.inputUploadFile1.nativeElement.value = "";
  }
  public async getFile(e) {
    this.blockUI.start();
    if (typeof FileReader !== "undefined") {
      this.setFormChanging();
      const files = e.target.files;
      let size = 0;
      const filesUpload = this.fileUploadArray;
      const filesSrc = this.fileUploadSrc;
      filesUpload.forEach(item => {
        size += item.size
      });
      const allFile = filesUpload.map(item => {
        return { name: item.name };
      });

      const fileSave = [];
      const fileSrc = [];
      const fileAttach = [];
      const limitSize = this.maxSize; // 10MB
      let error: 'type' | 'size' = null;
      for (let file of files) {
        if (file.type !== 'application/pdf') {
          error = 'type';
          break;
        } else if(file.size > this.maxPerMainFile) {
          error = 'size';
          break;
        } else {
          // if (file.size <= limitSize) {
            size += file.size;
            const fileName = file.name;
            const dotIndex = fileName.lastIndexOf('.');
            const namePart = fileName.substring(0, dotIndex);
            const extPart = fileName.substring(dotIndex + 1).toLowerCase();
            const newFileName  = `${namePart}.${extPart}`;
            file = new File([file], `${newFileName}`, { type: file.type });
            const src = await this.checkContentTypeThenAddFile(file);
            if (src) {
              const nameFileSplit = file.name.substring(0, file.name.length - 4);
              const find = allFile.find(item => {
                return item.name === file.name;
              });
              const specials = [
                '/', '.', '*', '+', '?', '|',
                '(', ')', '[', ']', '{', '}', '\\'
              ];
              const regSpe = new RegExp('(\\' + specials.join('|\\') + ')', 'gim');
              const nameFileReg = nameFileSplit.replace(regSpe, '\\$1');
              const sameName = allFile.filter(item => {
                return new RegExp(nameFileReg + '\\([0-9]{1,}\\)\.' + 'pdf').test(item.name);
              });
              const number = sameName.map(item => {
                const listNumber = item.name.match(/\([0-9]{1,}\)/g);
                return listNumber.length ? listNumber[listNumber.length - 1].replace('(', '').replace(')', '') : null;
              });
              if (find && !number.length) {
                file = new File([file], `${nameFileSplit}(1).pdf`, { type: file.type });
              } else if (find && number.length) {
                const numbers = Array.from({ length: 100 }, (v, i) => i + 1);
                let index;
                for (const iterator of numbers) {
                  if (!number.includes(iterator.toString())) {
                    index = iterator;
                    break;
                  }
                }
                file = new File([file], `${nameFileSplit}(${index}).pdf`, { type: file.type });
              }
              file.id = encodeURIComponent(file.name);
              fileSave.push(file);
              fileSrc.push(src);
              allFile.push(file);
              const path = +new Date() + ""
              fileAttach.push({
                file: file,
                src: src,
                path: path
              })

            } else {
              error = 'type';
              break;
            }
          this.fileUploadSize = size;
        }
      }
      if (error) {
        switch (error) {
          case 'type':
            if (!this.toastr.findDuplicate(this.message.getMessage('messages.only_accept_pdf'), true, true)) {
              this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
              this.blockUI.stop();
            }
            break;
          case 'size':
            if (!this.toastr.findDuplicate(this.message.getMessage('validation.max_size_file_upload'), true, true)) {
              this.toastr.error(this.message.getMessage('validation.max_size_file_upload').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024))));
              this.blockUI.stop();
            }
            break;
          default: break;
        }
      } else if (fileSave.length) {
        let totalSize = size;
        this.createContractService.dataDocumentParentNewUploadContractAttachments.getValue().forEach(attach => {
          if (attach.fileSize !== undefined) {
              totalSize = totalSize + attach.fileSize;
          } else {
              totalSize = totalSize + attach.size;
          }
        });
        this.createContractService.mainContractAttactment.getValue().forEach(mainAttach => {
          if (mainAttach.fileSize !== undefined) {
            totalSize = totalSize + mainAttach.fileSize;
          } else if(mainAttach.size){
            totalSize = totalSize + mainAttach.size;
          } else if(mainAttach.file){
            totalSize = totalSize + mainAttach.file.size;
          } else {
            totalSize = totalSize
          }
        })
        if(totalSize > this.maxSizeSystem){
          this.toastr.error(this.message.getMessage('validation.max_size_file_contract').replace('{0}', String(Math.floor(this.maxSizeSystem/1024/1024))));
          this.blockUI.stop();
          return true
        }
        // merge 21511
        let infoFile = this.createContractService.infoFile.getValue() || [];
        fileSave.forEach(file => {
            const reader = new FileReader();
            reader.readAsBinaryString(file);
            reader.onloadend = () => {
              let count = 0;
              let dataLoad:any = reader.result;
              let match = dataLoad.match(/Type\/Pages\/Count (\d+)/);
              if (match) {
                count = match[1];
              } else {
                count = dataLoad.match(/\/Type[\s]*\/Page[^s]/g) ? dataLoad.match(/\/Type[\s]*\/Page[^s]/g).length : 0;
              }
              if(count != 0){
                infoFile.push({
                  id: file.id,
                  numberPage: Number(count)
                })
                this.createContractService.infoFile.next(infoFile);
              } else {
                const formData = new FormData;
                formData.append('file', file)
                this.blockUI.start()
                this.documentService.getInfoFile(formData).pipe(finalize(()=>this.blockUI.stop())).subscribe(res => {
                  if(res.success){
                    infoFile.push({
                      id: file.id,
                      numberPage: Number(res.data.numberPage) || 0
                    })
                    this.createContractService.infoFile.next(infoFile);
                  } else {
                    this.toastr.error(res.message);
                  }
                })
              }
            }
        });
        if (this.isBuyContract1Mb && !this.isBuyContract10Mb) {
          if (this.fileUploadSize <= this.size1MB) {
            const newFileArray = filesUpload.concat(fileSave);
            this.fileUploadArray = newFileArray;
            const newFileSrc = filesSrc.concat(fileSrc);
            this.fileUploadSrc = newFileSrc;
            if (!this.mainContractAttachments) {
              this.mainContractAttachments = [];
            }
            fileAttach.forEach(file => {
              this.mainContractAttachments.push({
                attachmentOrder: this.mainContractAttachments.length,
                id: '',
                fileSize: file.file.size,
                fileName: file.file.name,
                path: file.path,
                active: true,
                src: file.src
              })
              this.listPdfSrc[file.path] = file.src
            });
            if (this.mainContractAttachments.length > 0 && !this.pdfSrc) {
              this.pdfSrc = this.mainContractAttachments[0].src;
              if (!this.document.name.length) {
                let resultName = JSON.parse(JSON.stringify(this.mainContractAttachments[0].fileName));
                resultName = resultName.replace(/\.pdf$/, "")
                this.document.name = resultName.length > 100 ? resultName.slice(0, 100) : resultName;
              }
            }
        } else {
          this.toastr.error(this.message.getMessage('messages.uploaded_file_exceeds_the_allowed_1MB_capacity'));
          this.blockUI.stop();
          return;
        }
        } else {
          if (this.fileUploadSize <= this.size10MB) {
            const newFileArray = filesUpload.concat(fileSave);
            this.fileUploadArray = newFileArray;
            const newFileSrc = filesSrc.concat(fileSrc);
            this.fileUploadSrc = newFileSrc;
            if (!this.mainContractAttachments) {
              this.mainContractAttachments = [];
            }
            fileAttach.forEach(file => {
              this.mainContractAttachments.push({
                attachmentOrder: this.mainContractAttachments.length,
                id: '',
                fileSize: file.file.size,
                fileName: file.file.name,
                path: file.path,
                active: true,
                src: file.src
              })
              this.listPdfSrc[file.path] = file.src
            });
            if (this.mainContractAttachments.length > 0 && !this.pdfSrc) {
              this.pdfSrc = this.mainContractAttachments[0].src;
              if (!this.document.name.length) {
                let resultName = JSON.parse(JSON.stringify(this.mainContractAttachments[0].fileName));
                resultName = resultName.replace(/\.pdf$/, "")
                this.document.name = resultName.length > 100 ? resultName.slice(0, 100) : resultName;
              }
            }
          } else if (this.fileUploadSize > this.size10MB && this.fileUploadSize <= this.maxSizeSystem) {
            const residualCapacity = this.fileUploadSize - this.size10MB;
            if (!this.biggerThan10MBFileSize) {
              this.toastr.error(this.message.getMessage('messages.uploaded_files_exceed'));
              this.blockUI.stop();
              return;
            } else {
              if (this.biggerThan10MBFileSize >= residualCapacity) {
                const newFileArray = filesUpload.concat(fileSave);
                this.fileUploadArray = newFileArray;
                const newFileSrc = filesSrc.concat(fileSrc);
                this.fileUploadSrc = newFileSrc;
                if (!this.mainContractAttachments) {
                  this.mainContractAttachments = [];
                }
                fileAttach.forEach(file => {
                  this.mainContractAttachments.push({
                    attachmentOrder: this.mainContractAttachments.length,
                    id: '',
                    fileSize: file.file.size,
                    fileName: file.file.name,
                    path: file.path,
                    active: true,
                    src: file.src
                  })
                  this.listPdfSrc[file.path] = file.src
                });
                if (this.mainContractAttachments.length > 0 && !this.pdfSrc) {
                  this.pdfSrc = this.mainContractAttachments[0].src;
                  if (!this.document.name.length) {
                    let resultName = JSON.parse(JSON.stringify(this.mainContractAttachments[0].fileName));
                    resultName = resultName.replace(/\.pdf$/, "")
                    this.document.name = resultName.length > 100 ? resultName.slice(0, 100) : resultName;
                  }
                }
              } else {
                this.toastr.error(this.message.getMessage('messages.account_Subscribe_File_Download_Capacity_resource'));
                this.blockUI.stop();
                return;
              }
            }
          } else {
            this.toastr.error(this.message.getMessage('validation.file_config').replace('{0}', String(Math.floor(this.maxSizeSystem/1024/1024))));
            this.blockUI.stop();
            return;
          }
          // merge 21511
        }
      }
    }
    this.blockUI.stop();
    this.changeDataToTable()
    return true;
  }
  private async checkContentTypeThenAddFile(file: File): Promise<boolean> {
    const ct = await FileUtils.getContentType(file);
    let r = null;
    if (ContentType.PDF === ct) {
      r = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        // tslint:disable-next-line:no-shadowed-variable
        reader.onload = (e: any) => {
          resolve(e.target.result);
        };
        reader.readAsArrayBuffer(file);
      })
    }
    return new Promise((resolve, reject) => resolve(r));
  }
  changeDataToTable(){
    this.userSigns.map(res=>{
      let changeDataUser = this.listSign.filter(sign => sign.userId == res.userId)
      this.tranformDataUser(changeDataUser)
    });
    if (this.enterprises.value.length > 0) {
      this.enterprises.value.map(res=>{
        let changeDataCustomer = this.listSign.filter(sign => sign.idCustomer == res.idCustomer)
        this.tranformDataUser(changeDataCustomer)
      })
    }
    // sortData
    this.listSign.sort((a, b) => a.positionX - b.positionX);
    this.listSign.sort((a, b) => a.positionY - b.positionY);
    this.listSign.sort((a, b) => a.pageIndex - b.pageIndex);
    // render lai khung chan ky
    this.listSign.forEach(res=>{
      let idSign = (res.contractSignId || res.idNumber) +  '-sign-' + (res.enterpriseId || res.idCustomer) + '-approver-' + res.userId
      let sign = document.getElementById(idSign)
      if (res.isDelete) {
        if (sign) {
          sign.remove();
        }
      } else {
        if (sign) {
          const elements = sign.getElementsByTagName('div');
          if (elements.length) {
            elements.item(0).innerHTML = `${this.message.getMessage('signature')} ${res.name} ${this.message.getMessage('number_sign')} ${res.row_number}`
          }
        }
      }
    });
    this.listSign = this.listSign.filter(sign => !sign.isDelete);
  }

  tranformDataUser(data){
    this.sortData(this.fileUploadArray,data)
    return data
  }

  // Sap xep thu tu chan ky
  sortData(listFile, listSignSort){
    const getFileIndex = (fileId: string): number => {
      return listFile.findIndex((file) => file.id === fileId);
    };

    const listSign: any[] = [];

    if (Array.isArray(listSignSort)) {
      listSign.push(...listSignSort);
    }

    listSign.sort((a, b) => a.positionX - b.positionX);
    listSign.sort((a, b) => a.positionY - b.positionY);
    listSign.sort((a, b) => a.pageIndex - b.pageIndex);

    listSign.sort((prev, next) => {
      return (
        getFileIndex(prev.fileId) - getFileIndex(next.fileId)
      );
    });
    this.fileUploadArray.map((res: any)=>{
      let signFile = listSign.filter(sign => sign.fileId == res.id)
      signFile.forEach((row, index) =>{
        row.row_number = index +1;
    });
    })
    return listSign;
  }

  addEventsCheckFormChange() {
    // Check form change real-time when press printable key
    document
      .getElementById("pdfContainer")
      .addEventListener("keydown", (event) => {
        const keycode = event.keyCode;
        const isPrintableKey =
          (keycode > 47 && keycode < 58) || // number keys
          keycode === 8 ||
          keycode === 46 || // remove keys
          (keycode > 64 && keycode < 91) || // letter keys
          (keycode > 95 && keycode < 112) || // numpad keys
          (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
          (keycode > 218 && keycode < 223) || // [\]' (in order)
          keycode === 32; // space break
        if (isPrintableKey) {
          this.isFormChanging = true;
        }
      });

    // Check form change in document content
    document.getElementById("pdfContainer").addEventListener("change", (_) => {
      this.isFormChanging = true;
    });
  }
  onChangeZoom(event: any) {
    this.zoomLevel = event * 100;
  }
  onPagesLoaded(pagecount: PagesLoadedEvent): void {
    this.totalPage = pagecount.pagesCount;
  }
  changeFile(path: string, index: number) {
    this.pageIndex = 1;
    this.activeFile = index;
    if (this.listPdfSrc) {
      this.pdfSrc = this.listPdfSrc[path];
    }
  }
  textLayerRendered(e) {
    const element = e.source.textLayerDiv;
    const pageIndex = e.source.pageNumber
    // lấy các chữ ở trang pageNumber
    let signPosition;
    if ((this.listSign && this.listSign.length > 0)) {
      const files = this.fileUploadArray;
      let id;
      if (files && files.length && files[this.activeFile]) {
        const file = files[this.activeFile] as any;
        id = file.id ? file.id : null;
      }
      if (this.listSign && this.listSign.length > 0) {
        signPosition = this.listSign.filter((item) => {
          return item.pageIndex === pageIndex && item.fileId === id && !(item.id && item.id.includes('contract-code-config-'));
        });
      }
    }

    if (signPosition && signPosition.length > 0) {

      for (const position of signPosition) {

        const x = position.positionX;
        const y = position.positionY;
        const _width = position.widthRectangle;
        const _height = position.heightRectangle;
        const name = position.name;
        const id = position.enterpriseId || position.idCustomer;
        const userId = position.userId;
        const elWidth = element.offsetWidth;
        const elHeight = element.offsetHeight;
        const htmlNode = this.getStampWrapper(x, y, _width, _height, name, id, elWidth, elHeight, userId, null, null, [], false, (position.contractSignId || position.idNumber), position.row_number);
        element.appendChild(htmlNode);
        if (position.enterpriseId) {
          if (position.enterpriseId === this.signNeedShow && position.userId === this.signApproverNeedShow) {
            const node = document.getElementById(`${position.contractSignId}-sign-${this.signNeedShow}-approver-${this.signApproverNeedShow}`);
            node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
          }
          this.signNeedShow = null;
          this.signApproverNeedShow = null;
        } else {
          if (position.customerId === this.signNeedShow && position.userId === this.signApproverNeedShow) {
            const node = document.getElementById(`${position.contractSignId}-sign-${this.signNeedShow}-approver-${this.signApproverNeedShow}`);
            node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });

          }
          this.signNeedShow = null;
          this.signApproverNeedShow = null;
        }

      }
    }

    element.addEventListener('mousedown', (eventMousedown) => {
      if (!this.isSelectPosition) {
        const target: HTMLElement = eventMousedown.target;
        if (target.id.includes('sign-') || (target.parentElement && target.parentElement.id && (target.parentElement.id.includes('sign-')))) {
          const id = target.id ? target.id : target.parentElement.id;
          const indexApprover = id.indexOf('-approver-');
          const indexSign = id.indexOf('-sign-');
          const signId = id.slice(indexSign + 6, indexApprover);
          const userId = id.slice(indexApprover + 10);
          const signUuid = id.slice(0, indexSign);

          if (target.className.includes('mat-icon')) {
            this.deleteSign(signId, userId, signUuid,null);
            return;
          }
          this.isSelectPosition = true;
          document.body.style.userSelect = 'none';
          const files = this.fileUploadArray;
          let idFile;
          if (files && files.length && files[this.activeFile]) {
            const file = files[this.activeFile] as any;
            idFile = file.id ? file.id : null;
          }
          this.signSelected = this.listSign.find(item => (item.enterpriseId == signId || item.idCustomer == signId) && item.fileId === idFile && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
          if (this.listSign.length) {
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              this.signSelected = this.listSign.find(item => {
                return (item.enterpriseId == signId || item.idCustomer == signId) && item.userId === userId && item.fileId === idFile && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)
              });
            } else {
              this.signSelected = this.listSign.find(item => (item.enterpriseId === signId ||  item.idCustomer == signId) && item.fileId === idFile && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
            }
          }

          let sign = null;
          let idSign = (this.signSelected.contractSignId || this.signSelected.idNumber) +  '-sign-' + (this.signSelected.enterpriseId || this.signSelected.idCustomer) + '-approver-' + this.signSelected.userId
          sign = document.getElementById(idSign)

          let position = {
            top: Number(sign.style.top.slice(0, -2)),
            left: Number(sign.style.left.slice(0, -2))
          }

          const node = document.getElementById(id);
          if (node) {
            node.remove();
          }
          if (Object.keys(this.signSelected || {}).length) {
            this.showFramesNotification(this.signSelected, position);
          }
        }
      }
    });

    element.addEventListener('mouseup', (eventMouseup) => {
      if (this.isSelectPosition) {
        this.isSelectPosition = false;
        document.body.style.userSelect = 'auto';
        // xoá dòng chọn vị trí
        const framesNotification = document.getElementById('show-frames-notification');
        if (framesNotification) {
          framesNotification.remove();
        }
        const offsetParent = element.offsetParent.dataset;
        const { pageNumber } = offsetParent;
        const boundingClient = element.getBoundingClientRect();
        const { top, left } = boundingClient;
        let signatureWidth, signatureHeight, widthHeightRatio;
        widthHeightRatio = this.widthRectangle / this.heightRectangle;
        if (Object.keys(this.signSelected || {}).length) {
          signatureWidth = this.signSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signSelected.heightRectangle * this.zoomLevel / 100;
        }
        let signZoom = this.zoomLevel / 100;
        let wrapperLeft = eventMouseup.clientX - signatureWidth / 2 - left;
        let wrapperTop = eventMouseup.clientY - signatureHeight / 2 - top;
        const newDiv = document.createElement('div');
        if (Object.keys(this.signSelected || {}).length) {
          let contractSignId = this.signSelected.contractSignId || this.signSelected.idNumber

          newDiv.setAttribute('id', `${contractSignId}-sign-${this.signSelected.enterpriseId || this.signSelected.idCustomer}-approver-${this.signSelected.userId}`);
          newDiv.style.width = `${signatureWidth}px`;
          newDiv.style.height = `${signatureHeight}px`;
          newDiv.style.fontFamily = 'Roboto, sans-serif';
        }
        if (wrapperLeft > 0) {
          newDiv.style.left = `${wrapperLeft}px`;
        }
        if (wrapperTop > 0) {
          newDiv.style.top = `${wrapperTop}px`;
        }
        newDiv.style.background = 'rgb(0,0,0,0.2)';
        newDiv.style.zIndex = '1';
        newDiv.style.border = '1px solid #999999';
        newDiv.style.lineHeight = '1.9';
        newDiv.style.color = '#00f';
        if (this.documentCodeNull && !this.isOnAutoNumber) {
          newDiv.style.color = 'red';
        } else {
          newDiv.style.color = '#00f';
        }
        newDiv.style.padding = `${10 * signZoom}px`;
        newDiv.style.position = 'absolute';
        newDiv.style.minWidth = `calc(300px / 10 * 3 * ${this.zoomLevel / 100})`;
        newDiv.style.minHeight = `calc(136px / 10 * 3 * ${this.zoomLevel / 100})`;
        newDiv.className = 'no-user-select';
        if (Object.keys(this.signSelected || {}).length) {
          newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
          <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; height: 100%; color: #00f; cursor: move;">
            ${this.message.getMessage('signature')} ${this.signSelected.name} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}
          </div>
        `;
        }
        this.changeDataToTable()
        //         Thay dổi kích thước chân ký
        const resizer = document.createElement('div');
        resizer.setAttribute('class', 'resize-div-bot-right');
        resizer.style.setProperty('--zoom', (signZoom).toString());
        newDiv.appendChild(resizer);
        element.appendChild(newDiv);

        let startX, startY;
        let signId;
        let indexApprover;
        let userId;
        let idSignature;
        let signUuid;

        resizer.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          startX = e.clientX;
          startY = e.clientY;
          document.documentElement.addEventListener('mousemove', doDrag);
          document.documentElement.addEventListener('mouseup', stopDrag);
          const targetSignId = e.target as Element;
          if (targetSignId.parentElement.id && targetSignId.parentElement.id.includes('contract-code-config-')) {
            idSignature = targetSignId.parentElement.id;
          }

           indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
           const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
           signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
           userId = targetSignId.parentElement.id.slice(indexApprover + 10);
           signUuid = targetSignId.parentElement.id.slice(0, indexSign);
        });

        // const signSelected = this.listSign.filter(item => item.enterpriseId === signId);

        let baseWidth = newDiv.offsetWidth;
        let baseHeight = newDiv.offsetHeight;

        const rerenderSign = () => {
          let signSelected, signatureSelected;
          if (this.listSign.length) {
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            } else {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            }
          }
          if (Object.keys(signSelected || {}).length && !Object.keys(signatureSelected || {}).length) {
            newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
            <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; height: 100%; color: #00f; cursor: move;">
              ${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${signSelected[0].row_number}
            </div>
        `;
          }

          newDiv.appendChild(resizer);
          resizer.style.removeProperty('--zoom');
          resizer.style.setProperty('--zoom', (signZoom).toString());
          return;
        }

        const doDrag = (e) => {
          e.stopPropagation();
          let signSelected, signatureSelected;
          if (this.listSign.length) {
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            } else {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            };
          }
          if (Object.keys(signSelected || {}).length && !Object.keys(signatureSelected || {}).length) {
            signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
            signatureHeight = signSelected[0].heightRectangle * this.zoomLevel / 100;
            newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
            newDiv.style.height = (signatureHeight + e.clientY - startY) + 'px';
            let widthHeightRatio_Drag = newDiv.offsetWidth / newDiv.offsetHeight;
            if (widthHeightRatio !== widthHeightRatio_Drag) {
              newDiv.style.height = (newDiv.offsetWidth / widthHeightRatio) + 'px';
              newDiv.style.width = (newDiv.offsetHeight * widthHeightRatio) + 'px';
            }
          } else if (Object.keys(signatureSelected || {}).length) {
            signatureWidth = signatureSelected[0].widthRectangle * this.zoomLevel / 100;
            signatureHeight = signatureSelected[0].heightRectangle * this.zoomLevel / 100;
            newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
            newDiv.style.height = (signatureHeight + e.clientY - startY) + 'px';
          }

          newDiv.style.maxWidth = (element.offsetWidth - wrapperLeft) + 'px';
          newDiv.style.maxHeight = (element.offsetHeight - wrapperTop) + 'px';
          rerenderSign();
        }

        const stopDrag = (e) => {
          e.stopPropagation();
          if (newDiv.offsetWidth / 2 + wrapperLeft < 0 || newDiv.offsetHeight / 2 + wrapperTop < 0) {
            newDiv.style.width = baseWidth + 'px';
            newDiv.style.height = baseHeight + 'px';
          } else {
            baseWidth = newDiv.offsetWidth;
            baseHeight = newDiv.offsetHeight;
          }
          rerenderSign();
          if (this.listSign.length) {
            this.listSign.forEach(item => {
              if ((item.enterpriseId === signId || item.idCustomer === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId))) {
                item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
                item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
              }
            });
          }
          document.documentElement.removeEventListener('mousemove', doDrag);
          document.documentElement.removeEventListener('mouseup', stopDrag);
        }

        const zoomLevel = this.zoomLevel;
        const files = this.fileUploadArray;
        let id;
        if (files && files.length && files[this.activeFile]) {
          const file = files[this.activeFile] as any;
          id = file.id ? file.id : null;
        }
        if (this.listSign.length && Object.keys(this.signSelected || {}).length) {
          this.listSign.forEach(item => {
            if (((item.enterpriseId === this.signSelected.enterpriseId && this.signSelected.enterpriseId) ||
            (item.idCustomer === this.signSelected.idCustomer && this.signSelected.idCustomer)) &&
            item.userId === this.signSelected.userId && item.fileId === id  &&
            ((item.contractSignId && this.signSelected.contractSignId === item.contractSignId) || (this.signSelected.idNumber === item.idNumber && item.idNumber))) {


              item.stampPositionLeft = eventMouseup.clientX - signatureWidth / 2 - left;
              item.stampPositionTop = eventMouseup.clientY - signatureHeight / 2 - top;
              item.positionX = 100 * wrapperLeft / zoomLevel;
              item.positionY = 100 * wrapperTop / zoomLevel;
              item.pageIndex = pageIndex;
              item.zoom = this.zoomLevel / 100;
              item.pdfSrc = this.pdfSrc;
              item.pageNumber = pageNumber;
              item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
              item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
            }
          });
          this.signSelected = null;
        }
      }
      this.changeDataToTable()
    })
    element.addEventListener('click', (clickEvent) => {
      if (!this.isSelectPosition) {
        const target: HTMLElement = clickEvent.target;
        if (target.id && target.id.includes('contract-code-config-') || target.id.includes('sign-') || (target.parentElement && target.parentElement.id && (target.parentElement.id.includes('sign-') || target.parentElement.id.includes('contract-code-config-')))) {
          const id = target.id ? target.id : target.parentElement.id;
          const indexApprover = id.indexOf('-approver-');
          const indexSign = id.indexOf('-sign-');
          const signId = id.slice(indexSign + 6, indexApprover);
          const userId = id.slice(indexApprover + 10);
          const signUuid = id.slice(0, indexSign); // todo
          if (target.className.includes('mat-icon')) {
            this.deleteSign(signId, userId, signUuid,null);
            return;
          }
        }
      }
    });
    element.addEventListener('mouseleave', (mouseoverEvent) => {
      this.isMouseLeave = true;
      if (this.isSelectPosition) {
        const nodeOther = document.getElementById('show-frames-notification');
        if (nodeOther) {
          nodeOther.remove();
        }
      }
    });
    element.addEventListener('mouseover', () => {
      this.isMouseLeave = false;
    });
    element.addEventListener('wheel', (wheelEvent) => {
      if (this.isSelectPosition) {
        let node = element.querySelector('#show-frames-notification');
        const nodeOther = document.getElementById('show-frames-notification');
        if (!node && nodeOther) {
          nodeOther.remove();
        }
        const boundingClient = element.getBoundingClientRect();
        const { top, left } = boundingClient;
        let signatureWidth, signatureHeight;
        if (Object.keys(this.signSelected || {}).length) {
          signatureWidth = this.signSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signSelected.heightRectangle * this.zoomLevel / 100;
        }
        let signZoom = this.zoomLevel / 100;
        const widthHeightRatio = this.widthRectangle / this.heightRectangle;
        if (!node) {
          const stampNode = document.createElement('div');
          if (Object.keys(this.signSelected || {}).length) {
            stampNode.innerHTML = `<div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
            <div id="notify_outside" style="position: absolute;top: -${35 * signZoom}px;left: ${(this.signSelected.widthRectangle / 2 - 150) * signZoom}px;color: red; width: ${300 * signZoom}px">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
              ${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : null} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}
            </div>`;
            stampNode.style.width = `${signatureWidth}px`;
            stampNode.style.height = `${signatureHeight}px`;
          }
          this.stampWrapper = stampNode;
          stampNode.style.width = `${signatureWidth}px`;
          stampNode.style.height = `${signatureHeight}px`;
          stampNode.style.position = 'absolute';
          stampNode.setAttribute('id', 'show-frames-notification');
          stampNode.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
          stampNode.style.top = `${(wheelEvent.clientY - signatureHeight / 2 - top)}px`;
          stampNode.style.zIndex = '1';
          stampNode.style.background = 'rgb(0,0,0,0.2)';
          stampNode.style.border = '1px solid';
          stampNode.style.lineHeight = '1.9';
          stampNode.style.color = '#00f';
          stampNode.style.fontFamily = 'Roboto, sans-serif';
          stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
          stampNode.style.minWidth = `calc(300px / 10 * 3 * ${this.zoomLevel / 100})`;
          stampNode.style.minHeight = `calc(136px / 10 * 3 * ${this.zoomLevel / 100})`;
          stampNode.className = 'no-user-select';
          //         Thay dổi kích thước chân ký
          const resizer = document.createElement('div');
          resizer.setAttribute('class', 'resize-div-bot-right');
          resizer.style.setProperty('--zoom', (signZoom).toString());
          stampNode.appendChild(resizer);
          element.appendChild(stampNode);

          let startX;
          let startY;
          let signId;
          let indexApprover;
          let userId;
          let idSignature;
          let signUuid;
          resizer.addEventListener('mousedown', (e) => {
            e.stopPropagation();
            startX = e.clientX;
            startY = e.clientY;
            document.documentElement.addEventListener('mousemove', doDrag);
            document.documentElement.addEventListener('mouseup', stopDrag);
            const targetSignId = e.target as Element;
            if (targetSignId.parentElement.id && targetSignId.parentElement.id.includes('contract-code-config-')) {
              idSignature = targetSignId.parentElement.id;
            }
            // indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
            // signId = targetSignId.parentElement.id.slice(5, indexApprover);
            // userId = targetSignId.parentElement.id.slice(indexApprover + 10);

            indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
            const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
            signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
            userId = targetSignId.parentElement.id.slice(indexApprover + 10);
            signUuid = targetSignId.parentElement.id.slice(0, indexSign);
          });

          let baseWidth = stampNode.offsetWidth;
          let baseHeight = stampNode.offsetHeight;

          const rerenderSign = () => {
            let signSelected, signatureSelected;
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId ) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
            } else {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)));
            };
            if (Object.keys(this.signSelected || {}).length) {
              stampNode.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
              <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
                ${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${this.signSelected[0].row_number}
              </div>
          `;
            }
            stampNode.appendChild(resizer);
            resizer.style.removeProperty('--zoom');
            resizer.style.setProperty('--zoom', (signZoom).toString());
            return;
          }

          const doDrag = (e) => {
            e.stopPropagation();
            let signSelected, signatureSelected;
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId ) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
            } else {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)));
            }
            if (Object.keys(this.signSelected || {}).length) {
              signatureHeight = signSelected[0].heightRectangle * this.zoomLevel / 100;
              signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
            }

            stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
            stampNode.style.height = (signatureWidth + e.clientY - startY) + 'px';
            stampNode.style.maxWidth = (element.offsetWidth - stampNode.offsetLeft) + 'px';
            stampNode.style.maxHeight = (element.offsetHeight - stampNode.offsetTop) + 'px';
            rerenderSign();
          }

          const stopDrag = (e) => {
            e.stopPropagation();
            if (stampNode.offsetWidth / 2 + stampNode.offsetLeft < 0 || stampNode.offsetHeight / 2 + stampNode.offsetTop < 0) {
              stampNode.style.width = baseWidth + 'px';
              stampNode.style.height = baseHeight + 'px';
            } else {
              baseWidth = stampNode.offsetWidth;
              baseHeight = stampNode.offsetHeight;
            }

            rerenderSign();
            if (this.listSign.length) {
              this.listSign.forEach(item => {
                if ((item.enterpriseId === signId || item.idCustomer === signId ) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)) {
                  item.widthRectangle = stampNode.offsetWidth * 100 / this.zoomLevel;
                  item.heightRectangle = stampNode.offsetHeight * 100 / this.zoomLevel;
                }
              });
            }
            document.documentElement.removeEventListener('mousemove', doDrag);
            document.documentElement.removeEventListener('mouseup', stopDrag);
          }

          element.appendChild(stampNode);
        } else {
          node.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
          node.style.top = `${(wheelEvent.clientY - signatureHeight / 2 - top)}px`;
        }
      }
    });
    element.addEventListener('mousemove', (mousemoveEvent) => {
      if (this.isSelectPosition) {
        // xoá dòng chọn vị trí
        const node = element.querySelector('#show-frames-notification');
        const nodeOther = document.getElementById('show-frames-notification');
        if (!node && nodeOther) {
          nodeOther.remove();
        }
        const boundingClient = element.getBoundingClientRect();
        const { top, left } = boundingClient;
        let signatureWidth, signatureHeight;
        if (Object.keys(this.signSelected || {}).length) {
          signatureWidth = this.signSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signSelected.heightRectangle * this.zoomLevel / 100;
        }

        let signZoom = this.zoomLevel / 100;
        if (!node) {
          const stampNode = document.createElement('div');
          if (Object.keys(this.signSelected || {}).length) {
            stampNode.innerHTML = `<div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;">
            <div id="notify_outside" style="position: absolute;top: -${35 * signZoom}px;left: ${(this.signSelected.widthRectangle / 2 - 150) * signZoom}px;color: red; width: ${300 * signZoom}px"></div>
              ${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : null} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}
            </div>`;
          }
          stampNode.style.width = `${signatureWidth}px`;
          stampNode.style.height = `${signatureHeight}px`;
          stampNode.style.position = 'absolute';
          stampNode.setAttribute('id', 'show-frames-notification');
          stampNode.style.left = `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`;
          stampNode.style.top = `${(mousemoveEvent.clientY - signatureHeight / 2 - top)}px`;
          stampNode.style.zIndex = '1';
          stampNode.style.background = 'rgb(0,0,0,0.2)';
          stampNode.style.border = '1px solid';
          stampNode.style.lineHeight = '1.9';
          if (this.documentCodeNull && !this.isOnAutoNumber) {
            stampNode.style.color = 'red';
          } else {
            stampNode.style.color = '#00f';
          }
          stampNode.style.fontFamily = 'Roboto, sans-serif';
          stampNode.style.padding = `${10 * signZoom}px`;
          stampNode.className = 'no-user-select';

          element.appendChild(stampNode);

        } else {
          node.style.left = `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`;
          node.style.top = `${(mousemoveEvent.clientY - signatureHeight / 2 - top)}px`;
        }
      }
    });
    element.style.opacity = '1';
    element.setAttribute('id', `text-pdf-layer-${pageIndex}-${this.activeFile}`);
    this.maxPageCurrent = pageIndex;
    this.changeDataToTable()
  }
  removeFile(index: number) {
    this.setFormChanging();
    if (index == this.activeFile) {
      if (this.activeFile > 0) {
        this.activeFile = this.activeFile - 1;
      } else {
        this.activeFile = 0;
      }

    } else if (index < this.activeFile) {
      this.activeFile = this.activeFile - 1;
    }

    const oldDataMainContractAttachments = [...this.mainContractAttachments];
    const fileDelete = oldDataMainContractAttachments[index] ? oldDataMainContractAttachments[index] : null as any;
    this.mainContractAttachments.splice(index, 1);
    this.mainContractAttachments = [...this.mainContractAttachments.map((data, index) => ({
      ...data,
      attachmentOrder: index
    }))];
    if (this.mainContractAttachments.length == 0) {
      this.pdfSrc = null;
      this.activeFile = 0;
      this.fileUploadArray = [];
      this.fileUploadArray = [];
      this.fileUploadSrc = [];
    } else {
      this.pdfSrc = this.listPdfSrc[this.mainContractAttachments[this.activeFile].path]
    }
    let newFile = [];
    let file = [...this.fileUploadArray];
    let fileSrc = this.fileUploadSrc;

    this.mainContractAttachments.forEach((mainAttachment) => {
      file.forEach((fileNew) => {
        if(mainAttachment.fileName === fileNew.name) {
          newFile.push(fileNew);
        }
      })
    });
    file = [...newFile];
    this.fileUploadArray = file;
    fileSrc.splice(index, 1);
    this.fileUploadSrc = fileSrc;
    if (fileDelete) {
      if (this.listSign.length) {
        this.listSign = this.listSign.filter(item => {
          return item.fileId !== fileDelete.fileName
        });
      }
    }
    // this.selectedFile = '';
    // this.selectedFileSign = this.activeFile;
    // this.selectedNumberPage = null;
  }
  createTplModal(tplTitle: TemplateRef<{}>, tplContent: TemplateRef<{}>, tplFooter: TemplateRef<{}>): void {
    this.tplModal = this.modalService.create({
      nzTitle: tplTitle,
      nzContent: tplContent,
      nzFooter: tplFooter,
      nzMaskClosable: true,
      nzClosable: true,
      nzOnOk: () => console.log('Click ok')
    });
  }

  destroyTplModal(): void {
    setTimeout(() => {
      this.tplModal.destroy();
    }, 300);
  }
  onSubmit(event: Event) {
    if (this.ngForm.invalid) {
      this.onValidateGeneralInfo()
    } else {
      event.preventDefault();
      // this.submitData();
    }
  }
  public onValidateGeneralInfo() {
    const invalid = [];
    const controls = this.ngForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push({
          name,
          error: controls[name].errors
        });
      }
    }
    this.panels.forEach((x, index) => {
      if (index === 0) {
        x.open();
      }
    });
    this.blockUI.stop();
  }
  selectedChange(event) {
    this.setFormChanging();
    const objectServiceType = this.serviceTypes.find(item => item.id == event.value);
    if (objectServiceType) {
      this.selectedServiceType = objectServiceType;
      if (objectServiceType.internalFlowNotEdit) {
        const userSignData = this.userSigns.find(user => user.role == '1');
        if (userSignData) {
          this.listSign.forEach(sign => {
            if (sign.enterpriseSignId === userSignData.enterpriseId) {
              sign.isDelete = true
            }
          })
        }
        this.userSigns = [];
        this.changeDataToTable();
      }
    }
    this.isOnAutoNumber = objectServiceType.isOnAutoNumber;
    if (objectServiceType && objectServiceType.isOnAutoNumber) {
      this.document.code = '';
    }
    this.checkFocus = false;
  }
  getListServiceTypes() {
    this.documentTypeService.getServiceTypes(this.document.enterpriseId, 1).subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      this.serviceTypes = rs.data;
      this.document.serviceType = rs.data[0].id;
      this.selectedServiceType = rs.data[0];
      this.isOnAutoNumber = rs.data[0].isOnAutoNumber;
      if (rs.data[0] && rs.data[0].isOnAutoNumber) {
        this.document.code = '';
      }
      this.filteredServiceTypes.next(this.serviceTypes.slice());
    });
  }
  openDialogAdd() {
    const dialogRef = this.dialog.open(AddDocumentGroupV3Component, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '70%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((rs) => {
      this.getServiceTypeWhenAddDocument(rs);
    });
  }
  getServiceTypeWhenAddDocument (res: any) {
    this.documentTypeService.getServiceTypes(this.document.enterpriseId, 1).subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      this.serviceTypes = rs.data;
      this.filteredServiceTypes.next(this.serviceTypes.slice());
      if (res) {
        const objectServiceType = this.serviceTypes.find(item => item.id == res.data);
        if (objectServiceType) {
          this.selectedServiceType = objectServiceType;
        }
        this.isOnAutoNumber = objectServiceType.isOnAutoNumber;
        if (objectServiceType && objectServiceType.isOnAutoNumber) {
          this.document.code = '';
        }
        this.checkFocus = false;
        this.document.serviceType = res.data;
      }
    });
  }
  openDialogProcedure(type: number, $event) {
    $event.stopPropagation();
    const dialogRef = this.dialog.open(ProcedureComponent, {
      width: '70%',
      data: {
        type: type,
        internalFlowNotEdit: this.selectedServiceType ? this.selectedServiceType.internalFlowNotEdit : null
      }
    })

    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.setFormChanging();
      }
    });
  }
  // Hàm tìm kiếm người dùng ký duyệt
  onChangeUserSignSearch(event): void {
    this.setFormChanging();
    if (event.target.value.trim().length > 0) {
      this.nzCheckLoadingUserSign = true;
      this.autoUserService.fetchAutoDepartment(this.inputUserValue.trim())
        .then(result => {
          if (this.inputUserValue.trim().length > 0) {
            this.filteredUserOptions = result.sort(function (a, b) {
              return a.type.localeCompare(b.type)
            });
          } else {
            this.filteredUserOptions = [];
          }
        }).finally(() => {
          this.nzCheckLoadingUserSign = false;
        });
    } else {
      this.inputUserValue = '';
      this.filteredUserOptions = [];
    }
  }

  autocompleteUserSelected($event: any, model: any) {
    if ($event.isUserInput) {
      this.setFormChanging();
      if ((!model.representativeId || !model.representativeIsActive) && model.type === 'DEPARTMENT') {
        if (!model.representativeId) {
          this.toastr.error(this.message.getMessage('messages.no_representative'));
        } else {
          this.toastr.error(this.message.getMessage('messages.representative_inactive'));
        }
        return;
      }

      const userId = model.type === 'USER' ? model.id : model.representativeId;
      const userName = model.name;
      const departmentName = model.type === 'DEPARTMENT' ? model.departmentName : null;
      const departmentId = model.type === 'DEPARTMENT' ? model.departmentId : null;
      const email = model.email;

      if (!this.checkExistedUserOrDepartment(userName, departmentName, userId, departmentId, email, 'approve')) {
        let userSigns = this.userSigns
        const USER_SIGN = userSigns.filter(item => item.role === '1')[0];
        if (USER_SIGN) {
          userSigns.splice(userSigns.indexOf(USER_SIGN), 1);
        }

        userSigns = [
          ...userSigns,
          {
            order: userSigns.length ? userSigns[userSigns.length - 1].order + 1 : 1,
            userId: model.type === 'USER' ? model.id : model.representativeId,
            enterpriseId: model.enterpriseId,
            enterpriseSignId: localStorage.getItem('enterpriseId'),
            name: model.name,
            email: model.email,
            role: this.roleUser.APPROVE + '',
            phone: model.phone,
            isCreatedSide: true,
            departmentName: model.type === 'DEPARTMENT' ? model.departmentName : null,
            departmentId: model.type === 'DEPARTMENT' ? model.departmentId : null,
            isSignDigitalCertificate: model.isSignDigitalCertificate ? model.isSignDigitalCertificate : false,
            signConfig: model.signConfig ? this.setDataSignConfig(JSON.parse(model.signConfig)) : { resize: false, showImage: model.isSignDigitalCertificate ? true : (this.roleUser.APPROVE + '' ? true : false) },
            userPosition: model.userPosition
          }
        ];
        if (USER_SIGN) {
          USER_SIGN.order = userSigns.length + 1;
          userSigns.push(USER_SIGN);
        }
        this.userSigns = userSigns;
        this.inputUserValue = '';
        this.inputUserSignValue = '';
      }
    }
  }
  checkExistedUserOrDepartment(userName: string, departmentName: string, userId: string, departmentId?: string, email?: string, role?: string) {
    let userExist = 0;
    let departmentExist = 0;
    let roleType = false;

    const existedList = this.userSigns.filter((e) => {
      if (departmentId && e.departmentId === departmentId) {
        departmentExist++;
        if (e.role === '1') {
          roleType = true;
        }
        return true;
      } else if (e.userId === userId) {
        userExist++;
        if (e.role === '1') {
          roleType = true;
        }
        return true;
      }
    });

    if (existedList.length > 0) {
      if (departmentExist > 0) {
        if (role === 'sign') {
          this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_department_apostrophe_duplicate_approve'), [departmentName]));
        } else {
          if (roleType) {
            this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_department_apostrophe_duplicate_sign'), [departmentName]));
          } else {
            this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_department_apostrophe_duplicate_approve'), [departmentName]));
          }
        }
      } else if (userExist > 0) {
        if (role === 'sign') {
          this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_approve'), [userName + ' - ' + email]));
        } else {
          if (roleType) {
            this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_sign'), [userName + ' - ' + email]));
          } else {
            this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_approve'), [userName + ' - ' + email]));
          }
        }
      }
      return true;
    } else {
      return false;
    }
  }
  setDataSignConfig(signConfig: any) {
    let newDataSignConfig = { ...signConfig };
    if(newDataSignConfig.resize === null || newDataSignConfig.resize === undefined) {
      newDataSignConfig = { ...newDataSignConfig, resize: false };
    }
    if(newDataSignConfig.showImage === null || newDataSignConfig.showImage === undefined) {
      newDataSignConfig = { ...newDataSignConfig, showImage: true };
    }
    return newDataSignConfig;
  }
  // /**
  //  * Lấy thông tin doanh nghiệp khi đăng nhập vào
  //  */
  getDefaultEnterprises() {
    this.enterpriseSignId = localStorage.getItem('enterpriseId');
    this.enterpriseService.getEnterpriseByID(this.enterpriseSignId).subscribe(rs => {
      if (rs && rs.data && !this.enterpriseSign.length) {
        this.defaultEnterprise = {
          enterpriseId: rs.data.id || '',
          order: 1,
          email: rs.data.email || '',
          enterpriseName: '',
          phone: rs.data.phone || '',
          status: this.enumContractEnterpriseStatus.NO_PROCESS,
          isCreatedSide: true,
          customerId: '',
          name: rs.data.name || '',
          certificateNo: (rs.data.taxCode && rs.data.taxCode.length > 0) ? rs.data.taxCode : rs.data.certificateNo,
          useDataForTemplate: false,
          isSignNoLogin: rs.data.isSignNoLogin,
          signConfig: rs.data.signConfig ? this.setDataSignConfig(JSON.parse(rs.data.signConfig)) : { resize: false, showImage: true }
        }
        this.enterpriseSign.push(this.defaultEnterprise);
      }
    }, (error) => console.log(error));

  }

  //hàm tìm kiếm người dùng ký duyệt
  onChangeUserSearch(event): void {
    if (event.target.value.trim().length > 0) {
      this.setFormChanging();
      this.nzCheckLoadingUser = true;
      this.autoUserService.fetchAutoDepartment(this.inputUserSignValue.trim())
        .then(result => {
          if (this.inputUserSignValue.trim().length > 0) {
            this.filteredUserOptions = result.sort(function (a, b) {
              return a.type.localeCompare(b.type)
            });
          } else {
            this.filteredUserOptions = [];
          }
        }).finally(() => {
          this.nzCheckLoadingUser = false;
        });
    } else {
      this.inputUserSignValue = '';
      this.filteredUserOptions = [];
    }
  }
  autocompleteUserSignSelected($event: any, model: any) {
    if ($event.isUserInput) {
      this.setFormChanging();
      if ((!model.representativeId || !model.representativeIsActive) && model.type === 'DEPARTMENT') {
        if (!model.representativeId) {
          this.toastr.error(this.message.getMessage('messages.no_representative'));
        } else {
          this.toastr.error(this.message.getMessage('messages.representative_inactive'));
        }
        return;
      }

      const userId = model.type === 'USER' ? model.id : model.representativeId;
      const userName = model.name;
      const departmentName = model.type === 'DEPARTMENT' ? model.departmentName : null;
      const departmentId = model.type === 'DEPARTMENT' ? model.departmentId : null;
      const email = model.email;

      if (!this.checkExistedUserOrDepartment(userName, departmentName, userId, departmentId, email, 'sign')) {
        // Re-set all old members to "APPROVE" role
        let userSigns = this.userSigns
        userSigns = [
          ...userSigns,
          {
            order: userSigns.length + 1,
            userId: model.type === 'USER' ? model.id : model.representativeId,
            enterpriseId: model.enterpriseId,
            enterpriseSignId: localStorage.getItem('enterpriseId'),
            name: model.name,
            email: model.email,
            role: this.roleUser.SIGN + '',
            phone: model.phone,
            isCreatedSide: true,
            departmentName: model.type === 'DEPARTMENT' ? model.departmentName : null,
            departmentId: model.type === 'DEPARTMENT' ? model.departmentId : null,
            isSignDigitalCertificate: model.isSignDigitalCertificate ? model.isSignDigitalCertificate : false,
            signConfig: model.signConfig ?this.setDataSignConfig(JSON.parse(model.signConfig)) : { resize: false, showImage: model.isSignDigitalCertificate ? true : (this.roleUser.SIGN + '' == '1' ? true : false) },
            userPosition: model.userPosition
          }
        ];
        this.userSigns = userSigns;
        this.inputUserValue = '';
        this.inputUserSignValue = '';
        this.clickSave = false;
      }
    }
  }
  get isShowSearchUserSign(): boolean {
    let isHaveSign:boolean = true;
    const userSign = this.userSigns.find(user => user.role == '1');
    if (userSign) {
      isHaveSign = false;
    }
    return isHaveSign;
  }
  deleteEnterprise(enterprise:any, isCreatedSide: boolean, index: number): void {
    this.setFormChanging();
    if (isCreatedSide) {
      // Xóa công ty lập
      this.enterpriseSign = this.enterpriseSign.filter(enter => enter.enterpriseId !== enterprise.enterpriseId);
      this.userSigns = [];
      this.listSign.forEach(sign => {
        if (sign.enterpriseSignId === enterprise.enterpriseId) {
          sign.isDelete = true
        }
      });
      this.changeDataToTable();
      this.inputUserValue = '';
      this.inputUserSignValue = '';
    } else {
      //xoa khach hang ngoai
      const enterpriseRemove = enterprise.value;
      this.enterprises.removeAt(index);
      this.listSign.forEach(sign => {
        if (sign.idCustomer === enterpriseRemove.idCustomer) {
          sign.isDelete = true
        }
      });
      this.changeDataToTable();
    }
    if (this.isInvalidSetPartyFlow) {
      this.toastr.error(this.message.getMessage('validation.error_enterprise_no_set_up'));
    }
  }
  deleteUser(user: any): void {
    this.setFormChanging();
    this.userSigns = this.userSigns.filter(d => d.userId !== user.userId);
    if (user && user.role == '1') {
     //xoa chan ky cua nguoi ky duyet
    this.listSign.forEach(sign => {
      if (sign.enterpriseSignId === user.enterpriseId) {
        sign.isDelete = true
      }
    });
     this.toastr.error(this.message.getMessage('validation.error_user_no_set_up'));
     this.clickSave = true;
     this.changeDataToTable();
    }
  }
  onClickResize(j: number, isCreateSide:boolean){
    this.setFormChanging();
    if (isCreateSide) {
      this.userSigns[j].signConfig.resize = !this.userSigns[j].signConfig.resize;
    } else {
      const isResize = this.enterprises.at(j).get('resize').value;
      this.enterprises.at(j).get('resize').setValue(!isResize);
    }
  }
  //Thêm khung ký tên doanh nghiệp
  addSign(item: any, index:number = 0) {
    let userSign;
    if (item.isCreatedSide) {
      userSign = item;
    } else {
      userSign = item.value;
    }
    // Lay so thu tu chan ky
    const idNumber = uuid.v4();
    if (!this.pdfSrc) {
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.error_contract_quickly'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.error_contract_quickly'));
      }
      const listBtn = document.querySelectorAll("button");
      listBtn.forEach((btn) => {
        if (btn.className.includes('mat-stroked-button-create-document')) {
          btn.classList.add("btn_glowing");
        }
      });
      setTimeout(() => {
        listBtn.forEach((btn) => {
          btn.classList.remove("btn_glowing");
        });
      }, 5000);
      return;
    }
    if (!document.getElementById(`text-pdf-layer-${this.pageIndex}-${this.activeFile}`)) {
      setTimeout(() => {
        this.addSign(userSign, index);
      }, 100);
      return;
    }
    this.returnToPrevPosition();
    if (!this.isSelectPosition) {
      const itemNew = JSON.parse(JSON.stringify(userSign));
      itemNew.idNumber = idNumber
      itemNew.row_number = 1
      const element: any = document.getElementById(`text-pdf-layer-${this.pageIndex}-${this.activeFile}`);
      const view: any = document.getElementById('viewerContainer');
      const elementBounding = element.getBoundingClientRect();
      const viewBounding = view.getBoundingClientRect();
      const offsetParent = element.offsetParent.dataset;
      const { pageNumber } = offsetParent;
      let signatureWidth = this.widthRectangle * this.zoomLevel / 100;
      let heightRectangle = this.heightRectangle * this.zoomLevel / 100;
      let signZoom = this.zoomLevel / 100;
      const widthHeightRatio = this.widthRectangle / this.heightRectangle;
      const wrapperLeft = 0;
      let wrapperTop = 0;
      if (viewBounding.y - elementBounding.y > heightRectangle) {
        wrapperTop = viewBounding.y - elementBounding.y;
      }
      const newDiv = document.createElement('div');
      // Sua Id chu ky

      newDiv.setAttribute('id', `${idNumber}-sign-${itemNew.enterpriseId || itemNew.idCustomer }-approver-${itemNew.userId}`);
      newDiv.style.left = `${wrapperLeft}px`;
      newDiv.style.top = `${wrapperTop}px`;
      newDiv.style.width = `${signatureWidth}px`;
      newDiv.style.height = `${heightRectangle}px`;
      newDiv.style.background = 'rgb(0,0,0,0.2)';
      newDiv.style.zIndex = '1';
      newDiv.style.border = '1px solid #999999';
      newDiv.style.lineHeight = '1.9';
      newDiv.style.color = '#00f';
      newDiv.style.fontFamily = 'Roboto, sans-serif';
      newDiv.style.padding = `${10 * signZoom}px`;
      newDiv.style.position = 'absolute';
      newDiv.style.minWidth = (300 / 10 * 3 * signZoom) + 'px';
      newDiv.style.minHeight = (136 / 10 * 3 * signZoom) + 'px';
      newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
      <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
            ${this.message.getMessage('signature')} ${itemNew.name} ${this.message.getMessage('number_sign')} ${itemNew.row_number}
          </div>
          `;
      // <div class="resize-div-bot-right" style="--zoom: ${this.zoomLevel}"></div>
      newDiv.className = 'no-user-select';
      const zoomLevel = this.zoomLevel;
      itemNew.stampPositionLeft = 0;
      itemNew.stampPositionTop = 0;
      itemNew.positionX = 100 * wrapperLeft / zoomLevel;
      itemNew.positionY = 100 * wrapperTop / zoomLevel;
      itemNew.pageIndex = this.pageIndex;
      itemNew.zoom = this.zoomLevel / 100;
      itemNew.pdfSrc = this.pdfSrc;
      itemNew.pageNumber = pageNumber;
      itemNew.widthRectangle = this.widthRectangle;
      itemNew.heightRectangle = this.heightRectangle;
      const files = this.fileUploadArray;
      let find;
      if (files && files.length && files[this.activeFile]) {
        const file = files[this.activeFile] as any;
        itemNew.fileId = file.id ? file.id : null;
      }
      if (!find) {
        const resizer = document.createElement('div');
        resizer.setAttribute('class', 'resize-div-bot-right');
        resizer.style.setProperty('--zoom', signZoom.toString());
        newDiv.appendChild(resizer);
        element.appendChild(newDiv);

        let startX, startY;
        let signId;
        let userId;
        let indexApprover;
        let idNumber;
        let signUuid;
        resizer.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          startX = e.clientX;
          startY = e.clientY;
          document.documentElement.addEventListener('mousemove', doDrag);
          document.documentElement.addEventListener('mouseup', stopDrag);
          const targetSignId = e.target as Element;


          indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
          const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
          signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
          userId = targetSignId.parentElement.id.slice(indexApprover + 10);
          signUuid = targetSignId.parentElement.id.slice(0, indexSign);

        });

        let baseWidth = newDiv.offsetWidth;
        let baseHeight = newDiv.offsetHeight;
        const rerenderSign = () => {
          const signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId) && ((signUuid === item.idNumber && item.idNumber) || (signUuid === item.contractSignId && item.contractSignId)));
          newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
              <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
                ${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${signSelected[0].row_number}
              </div>
          `;
          newDiv.appendChild(resizer);
          resizer.style.removeProperty('--zoom');
          resizer.style.setProperty('--zoom', (signZoom).toString());
          return;
        }

        const doDrag = (e) => {
          e.stopPropagation();
          const signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId) && ((signUuid === item.idNumber && item.idNumber) || (signUuid === item.contractSignId && item.contractSignId)));
          signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
          heightRectangle = signSelected[0].heightRectangle * this.zoomLevel / 100;

          newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
          newDiv.style.height = (signatureWidth + e.clientY - startY) + 'px';
          newDiv.style.maxWidth = (element.offsetWidth - wrapperLeft) + 'px';
          newDiv.style.maxHeight = (element.offsetHeight - wrapperTop) + 'px';
          let widthHeightRatio_Drag = newDiv.offsetWidth / newDiv.offsetHeight;
          if (widthHeightRatio !== widthHeightRatio_Drag) {
            newDiv.style.height = (newDiv.offsetWidth / widthHeightRatio) + 'px';
            newDiv.style.width = (newDiv.offsetHeight * widthHeightRatio) + 'px';
          }
          rerenderSign();
        }

        const stopDrag = (e) => {
          e.stopPropagation();
          if (newDiv.offsetWidth / 2 + wrapperLeft < 0 || newDiv.offsetHeight / 2 + wrapperTop < 0) {
            newDiv.style.width = baseWidth + 'px';
            newDiv.style.height = baseHeight + 'px';
          } else {
            baseWidth = newDiv.offsetWidth;
            baseHeight = newDiv.offsetHeight;
          }
          rerenderSign();

          this.listSign.forEach(item => {
            if ((item.enterpriseId === signId || item.idCustomer === signId) && ((signUuid === item.idNumber && item.idNumber) || (signUuid === item.contractSignId && item.contractSignId))) {
              item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
              item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
            }
          });
          document.documentElement.removeEventListener('mousemove', doDrag);
          document.documentElement.removeEventListener('mouseup', stopDrag);
        }

        this.listSign.push(itemNew);
        this.changeDataToTable()
      }
    }
  }
  returnToPrevPosition() {
    if (Object.keys(this.signSelected || {}).length) {
      const position = this.signSelected;
      const element = document.getElementById(`text-pdf-layer-${position.pageIndex}-${this.activeFile}`);
      const x = position.positionX;
      const y = position.positionY;
      const _width = position.widthRectangle;
      const _height = position.heightRectangle;
      const name = position.name;
      const id = position.enterpriseId || position.customerId;
      const userId = position.userId;
      const elWidth = element.offsetWidth;
      const elHeight = element.offsetHeight;
      const htmlNode = this.getStampWrapper(x, y, _width, _height, name, id, elWidth, elHeight, userId, null, null, [], false, (this.signSelected.idNumber || this.signSelected.contractSignId), this.signSelected.row_number);
      element.appendChild(htmlNode);
      this.signSelected = null;
      this.isSelectPosition = false;
      document.body.style.userSelect = 'none';
    }
  }
  // tạo một thẻ điv với thông tin đc truyền vào để tạo ra khung ký
  getStampWrapper(positionX: number, positionY: number, width: number, height: number, name: string, id: number, elWidth: number, elHeight: number, idUser?: any, fontSize?: any, fontFamily?: any, fontStyle?: any[], isContractCodeConfig = false, uuid: string = '', row_number:any = '') {
    const stampNode = document.createElement('div');
    if (!isContractCodeConfig) {
      stampNode.setAttribute('id', `${uuid}-sign-${id}-approver-${idUser}`);
    } else {
      //neu la cau hinh ma hop dong
      stampNode.setAttribute('id', `${id}`);
    }


    // stampNode.innerHTML = this.genStampContent();
    let signatureWidth = width * this.zoomLevel / 100;
    let signatureHeight = height * this.zoomLevel / 100;

    const wrapperLeft = (positionX * this.zoomLevel) / 100;
    const wrapperTop = (positionY * this.zoomLevel) / 100;
    let signZoom = this.zoomLevel / 100;
    const widthHeightRatio = width / height;
    stampNode.style.position = 'absolute';
    stampNode.style.left = `${wrapperLeft}px`;
    stampNode.style.top = `${wrapperTop}px`;
    if (!isContractCodeConfig) {
      stampNode.style.width = `${signatureWidth}px`;
      stampNode.style.height = `${signatureHeight}px`;
      // stampNode.style.color = '#00f';
    }
    stampNode.style.minWidth = `calc(300px / 10 * 3 * ${this.zoomLevel / 100})`;
    stampNode.style.minHeight = `calc(136px / 10 * 3 * ${this.zoomLevel / 100})`;
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    stampNode.style.lineHeight = '1.9';
    stampNode.style.color = '#00f';

    if (fontSize) {
      stampNode.style.fontSize = fontSize;
    };
    if (fontFamily) {
      stampNode.style.fontFamily = fontFamily;
    } else {
      stampNode.style.fontFamily = 'Roboto, sans-serif';
    };
    if (fontStyle && fontStyle.includes('bold')) {
      stampNode.style.fontWeight = 'bold';
    }
    if (fontStyle && fontStyle.includes('italic')) {
      stampNode.style.fontStyle = 'italic';
    }
    if (fontStyle && fontStyle.includes('underline')) {
      stampNode.style.textDecoration = 'underline';
    }
    stampNode.style.padding = `${10 * signZoom}px`;
    stampNode.className = 'no-user-select';
    if (isContractCodeConfig) {
      stampNode.style.width = `${signatureWidth}px`;
      stampNode.style.height = `${signatureHeight}px`;
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        stampNode.style.color = 'red';
      }
      // stampNode.style.whiteSpace = 'nowrap';
      // stampNode.style.minWidth ='fit-content';
      stampNode.style.wordBreak = 'break-word';
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        stampNode.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
        <div class="text-danger" style="font-size: ${(fontSize ? fontSize : 12) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; cursor: move;">
          ${name}
        </div>
        `;
      } else {
        stampNode.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
        <div style="font-size: ${(fontSize ? fontSize : 12) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;">
          ${name}
        </div>
        `;
      }

    } else {
      stampNode.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
    <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
      ${this.message.getMessage('signature')} ${name} ${this.message.getMessage('number_sign')} ${row_number}
    </div>
    `;
      stampNode.style.display = 'flex';
      stampNode.style.justifyContent = 'center';
      stampNode.style.flexDirection = 'column';
      stampNode.style.textAlign = 'center';
      stampNode.style.fontWeight = 'bold';
    };
    // stampNode.innerHTML = `${name}`
    //         Thay dổi kích thước chân ký

    const resizer = document.createElement('div');
    resizer.setAttribute('class', 'resize-div-bot-right');
    resizer.style.setProperty('--zoom', (signZoom).toString());
    stampNode.appendChild(resizer);
    let startX, startY, signId, userId, indexApprover, idSignature, signUuid;
    resizer.addEventListener('mousedown', (e) => {
      e.stopPropagation();
      startX = e.clientX;
      startY = e.clientY;
      document.documentElement.addEventListener('mousemove', doDrag);
      document.documentElement.addEventListener('mouseup', stopDrag);
      const targetSignId = e.target as Element;
      indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
      const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
      signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
      userId = targetSignId.parentElement.id.slice(indexApprover + 10);
      signUuid = targetSignId.parentElement.id.slice(0, indexSign);
    });

    let baseWidth = signatureWidth;
    let baseHeight = signatureHeight;

    const rerenderSign = () => {
      let signSelected, signatureSelected;
      if (this.listSign.length) {
        if (userId !== null && userId !== undefined && userId !== 'undefined') {
          signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId ) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
        } else {
          signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.idCustomer === signId && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId))));
        };
      }
      stampNode.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
      <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
        ${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${signSelected[0].row_number}
      </div>
      `;
      stampNode.appendChild(resizer);
      resizer.style.removeProperty('--zoom');
      resizer.style.setProperty('--zoom', (signZoom).toString());
      return;
    }

    const doDrag = (e) => {
      e.stopPropagation();
      let signSelected, signatureSelected;
      if (this.listSign.length) {
        if (userId !== null && userId !== undefined && userId !== 'undefined') {
          signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId ) && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
        } else {
          signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
        }
      }
      signatureHeight = signSelected[0].heightRectangle * this.zoomLevel / 100;
      signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
      stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
      stampNode.style.height = (signatureHeight + e.clientY - startY) + 'px';
      let widthHeightRatio_Drag = stampNode.offsetWidth / stampNode.offsetHeight;
      if (widthHeightRatio !== widthHeightRatio_Drag) {
        stampNode.style.height = (stampNode.offsetWidth / widthHeightRatio) + 'px';
        stampNode.style.width = (stampNode.offsetHeight * widthHeightRatio) + 'px';
      }
      stampNode.style.maxWidth = (elWidth - stampNode.offsetLeft) + 'px';
      stampNode.style.maxHeight = (elHeight - stampNode.offsetTop) + 'px';

      rerenderSign();
    }

    const stopDrag = (e) => {
      e.stopPropagation();
      if (stampNode.offsetWidth / 2 + wrapperLeft < 0 || stampNode.offsetHeight / 2 + wrapperTop < 0) {
        stampNode.style.width = baseWidth + 'px';
        stampNode.style.height = baseHeight + 'px';
      } else {
        baseWidth = stampNode.offsetWidth;
        baseHeight = stampNode.offsetHeight;
      }

      rerenderSign();
      if (this.listSign.length) {
        this.listSign.forEach(item => {
          if ((item.enterpriseId === signId || item.customerId === signId ) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId))) {
            item.widthRectangle = stampNode.offsetWidth * 100 / this.zoomLevel;
            item.heightRectangle = stampNode.offsetHeight * 100 / this.zoomLevel;
          }
        });
      }
      document.documentElement.removeEventListener('mousemove', doDrag);
      document.documentElement.removeEventListener('mouseup', stopDrag);
    }

    return stampNode;
  }
  checkHaveSign(item: any, signData) {
    const files = this.fileUploadArray;
    let id;
    let check;
    let idSign = signData.contractSignId || signData.idNumber
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    if (item.enterpriseId) {
      check = this.listSign.find(sign =>
        (sign.enterpriseId === item.enterpriseId || sign.idCustomer === item.idCustomer) && sign.userId === item.userId && sign.fileId === id && (idSign === sign.contractSignId || idSign === sign.idNumber)
       );
       return check ? true : false;
    }
    check = this.listSign.find(sign =>
      sign.idCustomer === item.idCustomer && sign.userId === item.userId && sign.fileId === id && (idSign === sign.contractSignId || idSign === sign.idNumber)
    );
    return check ? true : false;
  }
  checkHaveSignCustomer(item: any, signData) {
    const files = this.fileUploadArray;
    let id;
    let check;
    let idSign = signData.contractSignId || signData.idNumber
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    const dataCustomer = item.value;
    check = this.listSign.find(sign =>
      sign.idCustomer === dataCustomer.idCustomer && sign.fileId === id && (idSign === sign.contractSignId || idSign === sign.idNumber)
    );
    return check ? true : false;
  }
  deleteSign(enterpriseId: string, userId: string, signUuid ,idCustomer) {
    this.setFormChanging();
    this.returnToPrevPosition();
    const files = this.fileUploadArray;
    let id;
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    if (userId === undefined || userId === '' || userId === null || userId === 'undefined') {
      // la khach hang ca nnhan + doannh nghiep
      if(idCustomer){
        this.listSign = this.listSign.filter(sign => {
          return (sign.enterpriseId !== enterpriseId && sign.idCustomer !== idCustomer && sign.fileId === id) || sign.fileId !== id ||
            ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
        });
      }
      else{
        this.listSign = this.listSign.filter(sign => {
          return (sign.enterpriseId !== enterpriseId && sign.idCustomer !== enterpriseId && sign.fileId === id) || sign.fileId !== id ||
            ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
        });
      }
    } else {
      this.listSign = this.listSign.filter(sign => {
        return (sign.userId !== userId && sign.fileId === id) || sign.fileId !== id ||  ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
      });
    }
    if(enterpriseId){
      const nodeOther = document.getElementById(`${signUuid}-sign-${enterpriseId}-approver-${userId}`);

      if (nodeOther) {
        nodeOther.remove();
      }
    }
    if(idCustomer){
      const nodeOther = document.getElementById(`${signUuid}-sign-${idCustomer}-approver-${userId}`);

      if (nodeOther) {
        nodeOther.remove();
      }
    }

    this.changeDataToTable()
  }
  deleteSignCustomer(enterprise: any, dataSign: any) {
    this.setFormChanging();
    this.returnToPrevPosition();
    const files = this.fileUploadArray;
    let id;
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    this.listSign = this.listSign.filter(sign => !(sign.idNumber === dataSign.idNumber));
    if(dataSign.idNumber){
      const nodeOther = document.getElementById(`${dataSign.idNumber}-sign-${dataSign.idCustomer}-approver-${dataSign.userId}`);
      if (nodeOther) {
        nodeOther.remove();
      }
    }

    this.changeDataToTable()
  }
  showFramesNotification(signSelected, position = null, isContractCodeConfig = false) {
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    const element: any = document.getElementById(`text-pdf-layer-${signSelected.pageIndex}-${this.activeFile}`);
    const signatureWidth = signSelected.widthRectangle * this.zoomLevel / 100;
    const heightRectangle = signSelected.heightRectangle * this.zoomLevel / 100;
    const newTop = position.top ? position.top : 0
    const newLeft = position.left ? position.left : 0
    const stampNode = document.createElement('div');
    const signZoom = this.zoomLevel / 100;
    stampNode.setAttribute('id', 'show-frames-notification');
    let contentNode;
    // keo chan ky
    if (!isContractCodeConfig) {
      contentNode = `<div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;">
      <div id="notify_outside" style="position: absolute;top: -${35 * signZoom}px;left: ${(signSelected.widthRectangle / 2 - 150) * signZoom}px;color: red; width: ${300 * signZoom}px">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
        ${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : null} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}
      </div>`;
    } else {
      // stampNode.style.whiteSpace = 'nowrap';
      stampNode.style.wordBreak = 'break-word';
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        contentNode = `
        <div class="text-danger" style="font-size: ${(signSelected.fontSize ? signSelected.fontSize : 12) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; cursor: move;">
          ${this.isOnAutoNumber ? this.configAutoNumber : this.message.getMessage('headertable.doc_code_required')}
        </div>
      `;
      } else {
        contentNode = `
        <div style="font-size: ${(signSelected.fontSize ? signSelected.fontSize : 12) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; color: #00f; cursor: move;">
          ${this.isOnAutoNumber ? this.configAutoNumber : this.document.code}
        </div>
      `;
      }

      //stampNode.style.minWidth = (300 / 10 * 3 * signZoom) + 'px';
      stampNode.style.minHeight = (136 / 10 * 3 * signZoom) + 'px';
      // stampNode.style.minWidth ='fit-content';
      stampNode.style.wordBreak = 'break-word';
    }
    stampNode.style.position = 'absolute';
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.innerHTML = contentNode;
    stampNode.style.left = `${newLeft}px`;
    stampNode.style.top = `${newTop}px`;
    stampNode.style.width = `${signatureWidth}px`;
    stampNode.style.height = `${heightRectangle}px`;
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    stampNode.style.lineHeight = '1.9';
    if (this.documentCodeNull && !this.isOnAutoNumber) {
      stampNode.style.color = 'red';
    } else {
      stampNode.style.color = '#00f';
    };
    if (signSelected.fontSize) {
      stampNode.style.fontSize = signSelected.fontSize;
    };
    if (signSelected.fontFamily) {
      stampNode.style.fontFamily = signSelected.fontFamily;
    } else {
      stampNode.style.fontFamily = 'Roboto, sans-serif';
    };
    if (signSelected.fontStyle && signSelected.fontStyle.includes('bold')) {
      stampNode.style.fontWeight = 'bold';
    }
    if (signSelected.fontStyle && signSelected.fontStyle.includes('italic')) {
      stampNode.style.fontStyle = 'italic';
    }
    if (signSelected.fontStyle && signSelected.fontStyle.includes('underline')) {
      stampNode.style.textDecoration = 'underline';
    }
    stampNode.style.padding = `${10 * signZoom}px`;
    stampNode.className = 'no-user-select';
    this.stampWrapper = stampNode;
    element.appendChild(stampNode);
  }
  getDecodeUri(item) {
    return decodeURI(item);
  }
  addEnterprise(isCreatedSide: boolean) {
    if (isCreatedSide) {
      this.enterpriseSign.push(this.defaultEnterprise);
    } else {
      const data = this.enterprises.value;
      let maxOrder = 1;
      if (data.length > 0) {
        maxOrder = Math.max.apply(Math, data.map(item => {
          return item.order;
        })) + 1;
      } else {
        if (this.enterpriseSign.length === 0) {
          maxOrder = 1;
        } else {
          maxOrder = 2;
        }
      }
      this.addFormEnterprise(maxOrder);
    }
  }
  addFormEnterprise(maxOrder: number) {
    const group = this.fb.group({
      order: [maxOrder],
      certificateNo: [null, [Validators.required, Validators.pattern(this.certificateNoPattern)]],
      name: [null, [Validators.required]],
      customerType: ['10000', [Validators.required]],
      email: [null, [Validators.pattern(this.emailPattern)]],
      phone: [null, [Validators.required, Validators.pattern(this.phonePattern2)]],
      enterpriseId: [''],
      enterpriseName: [''],
      customerId: [''],
      status: [1],
      isCreatedSide: [false],
      useDataForTemplate: [false],
      isSignNoLogin: [false],
      resize: [false],
      inputPartyValue: [''],
      idCustomer: [uuid.v4()],
      isLoading: [false],
    });
    this.enterprises.push(group);
  }
  // Thêm mới khách hàng vào danh sách
  autocompletePartySelected($event: any, model: any, index: number) {
    if ($event.isUserInput) {
        this.setFormChanging();
        const valueSelect = {
          enterpriseId: model.enterpriseId,
          email: model.email,
          enterpriseName: '',
          phone: model.phone,
          status: this.enumContractEnterpriseStatus.NO_PROCESS,
          isCreatedSide: model.isCreatedSide,
          customerId: model.customerId,
          name: model.name,
          certificateNo: (model.taxCode) ? model.taxCode : model.certificateNo,
          useDataForTemplate: false,
          isSignNoLogin: false,
          customerType : model.customerType == '10000' ? '10000' : '10001',
          signConfig: model.signConfig ? this.setDataSignConfig(JSON.parse(model.signConfig)) : { resize: false, showImage: false },
          resize: false,
          inputPartyValue: '',
          idCustomer: uuid.v4(),
          isLoading: false,
        }
        if (model.isCreatedSide) {
          if (this.enterpriseSign.length === 0) {
            this.enterpriseSign.push(this.defaultEnterprise);
          }
        } else {
          this.enterprises.at(index).patchValue(valueSelect);
        }
        // this.enterpriseSign = [
        //   ...this.enterpriseSign,
        // ];
        this.inputPartyValue = '';
        this.filteredPartyOptions = [];
    }
  }
  onChangePartySignSearch($event: any, i:number): void {
    this.filteredPartyOptions = [];
    if ($event.inputType.includes('insert') || $event.inputType.includes('delete')) {
      if (this.timeOutQueryServer) {
        clearTimeout(this.timeOutQueryServer);
      }
      this.timeOutQueryServer = setTimeout(() => {
        const nameValue = this.enterprises.at(i).get('inputPartyValue').value;
        if (nameValue && nameValue.trim().length > 0) {
          this.enterprises.at(i).patchValue({ isLoading: true });
          this.autoEnterpriseService.fetchAuto(nameValue.trim())
            .then(result => {
              if (result) {
                this.filteredPartyOptions = result;
              }
            }).finally(() => {
              this.enterprises.at(i).patchValue({ isLoading: false });
            });
        } else {
          this.inputPartyValue = '';
        }
      }, 500);

    }
  }
  // checkExistedParty(certificateNo: string) {
  //   const dataEnterprise = this.enterprises.value;
  //   const existedList = dataEnterprise.filter((e) => {
  //     return e.certificateNo === certificateNo;
  //   });

  //   return (existedList.length > 0);
  // }
  // checkExistedCreatorParty(): boolean {
  //   const existedList = this.enterpriseSign.filter((e) => {
  //     return e.isCreatedSide === true;
  //   });

  //   return existedList.length > 0;
  // }
  goToPage(enterpriseId: string, userId: string, signData ,customerId) {
    this.returnToPrevPosition();
    const files = this.fileUploadArray;
    let id;
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    let idSign = signData.contractSignId || signData.idNumber
    const node =enterpriseId ? document.getElementById(`${idSign}-sign-${enterpriseId}-approver-${userId}`) : document.getElementById(`${idSign}-sign-${customerId}-approver-${userId}`);
    const sign = this.listSign.find(sign => (sign.enterpriseId === enterpriseId || sign.customerId === enterpriseId ||sign.customerId === customerId) && sign.userId === userId && sign.fileId === id);
    this.pageIndex = sign ? sign.pageIndex : 1;
    if (node) {
      setTimeout(() => {
        node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      });
    } else {
      this.signNeedShow = sign.enterpriseId || sign.customerId;
      this.signApproverNeedShow = sign.userId;
    }
  }
  goToPageCustomer(index:number, signData: any) {
    this.returnToPrevPosition();
    const dataCustomer = this.enterprises.at(index).value;
    const files = this.fileUploadArray;
    let id;
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    let idSign = signData.contractSignId || signData.idNumber
    const node = document.getElementById(`${idSign}-sign-${dataCustomer.idCustomer}-approver-${dataCustomer.userId}`);
    const sign = this.listSign.find(sign => (sign.idCustomer === dataCustomer.idCustomer) && sign.idNumber === dataCustomer.idNumber && sign.fileId === id);
    this.pageIndex = sign ? sign.pageIndex : 1;
    if (node) {
      setTimeout(() => {
        node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      });
    } else {
      this.signNeedShow = sign.idCustomer;
      this.signApproverNeedShow = sign.userId;
    }
  }
  private async saveContract(isSaveDraft: boolean) {
    let document: DocumentDTO = DocumentDTO.build();
    document = Object.assign(document, this.document);
    if (this.isOnAutoNumber) {
      document['codeAuto'] = "";
    } else {
      document['codeAuto'] = document.code;
    }
    let customerSigns = [];
    if (this.enterprises.value) {
      customerSigns = this.enterprises.value.map(e => {
        if (e.resize) {
          e.signConfig = {
            resize: true,
            showImage: false
          }
        } else {
          e.signConfig = {
            resize: false,
            showImage: false
          }
        }
        return e;
      })
    }
    const recordsPartySign = [
      ...this.enterpriseSign,
      ...customerSigns
    ];
    const recordUserSign = this.userSigns;
    let recordsPartySignSort = [...recordsPartySign].sort((a, b) => a.order - b.order);
    let currentValue = 1;
    let previousValue = null;

    for (let i = 0; i < recordsPartySignSort.length; i++) {
        if (recordsPartySignSort[i].order !== previousValue) {
            previousValue = recordsPartySignSort[i].order;
            recordsPartySignSort[i].order = currentValue++;
        } else {
            recordsPartySignSort[i].order = currentValue - 1;
        }
    }
    // const minOrder = recordsPartySignSort[0].order;
    // recordsPartySignSort = recordsPartySignSort.map((item, index) => ({
    //   ...item,
    //   order: item.order - minOrder + 1,
    // }));
    document.enterpriseSign = JSON.parse(JSON.stringify(recordsPartySignSort));
    document.enterpriseSign = document.enterpriseSign.map(enter => {
      return {
        ...enter,
        signConfig: JSON.stringify(enter.signConfig)
      }
    })
    document.userSign = this.sortOrderUserSign(recordUserSign);
    document.userSign = document.userSign.map(user => {
      return {
        ...user,
        signConfig: JSON.stringify(user.signConfig)
      }
    })
    document.mainContractAttachments = this.fileUploadArray;
    document.signPositions = this.listSign.map(sign => {
      let signPosition: SignPosition = {
        pageNumber: sign.pageIndex ? sign.pageIndex : null,
        userId: sign.userId ? sign.userId : null,
        enterpriseId: sign.enterpriseId ? sign.enterpriseId : null,
        x: sign.positionX !== null ? sign.positionX : null,
        y: sign.positionY !== null ? sign.positionY : null,
        width: sign.widthRectangle ? sign.widthRectangle : null,
        height: sign.heightRectangle ? sign.heightRectangle : null,
        fileId: sign.fileId ? sign.fileId : null,
        certificateNo: sign.certificateNo ? sign.certificateNo : null
      }

      if (sign.customerId) {
        signPosition = Object.assign(signPosition, {customerId: sign.customerId})
      }
      return signPosition;
    });



    if (this.fileUploadArray.length) {
      const fileNeedSave = this.fileUploadArray.filter((item: any) => {
        return item.id.includes('.pdf');
      });
      if (fileNeedSave.length > 0) {
        this.commonService.uploadFilesDocument(fileNeedSave).subscribe(rs => {
          if(rs && !rs.success){
            this.toastr.error(rs.message);
          }
          if(rs && rs.code == ErrorCode.MaxSizeError){
            this.maxSize = rs.data > 0 ? rs.data : this.size10MB;
            this.mesage = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024)))
          } else {
            if (fileNeedSave.length === this.fileUploadArray.length) {
              const dataMainAttachmentNew = [];
              document.filePath = rs.data[0].path;
              document.fileNameUpdate = rs.data[0].fileName;
              document.fileSizeUpdate = rs.data[0].fileSize;
              document.mainContractAttachments.forEach((mainAttachment, index) => {
                rs.data.forEach(mainAttachmentNew => {
                  if(mainAttachment.name === mainAttachmentNew.fileName) {
                    dataMainAttachmentNew.push({
                      attachmentOrder: index,
                      ...mainAttachmentNew
                    });
                  }
                });
              });
              document.mainContractAttachments = [...dataMainAttachmentNew];
            }
            document.signPositions = document.signPositions.map(sign => {
              const fileDoc = document.mainContractAttachments.find(file => encodeURIComponent(file.fileName) === sign.fileId);
              if (fileDoc && fileDoc.id) {
                sign.fileId = fileDoc.id;
              }
              return sign;
            });

            this.callApiSaveFileDocument(document, isSaveDraft);
          }
        });
      }
    }
  }
  callApiSaveFileDocument(document: DocumentDTO, isSaveDraft: boolean) {
    if (!document.mainContractAttachments || !document.mainContractAttachments.length) {
      this.blockUI.stop();
      this.toastr.error(this.message.getMessage('messages.error_contract'));
      return;
    }
    if (!document.id) {
      this.documentService.addQuicklyDocument(document, this.documentCodeDuplicateHanlder.bind(this)).subscribe(rs => {
        if (rs && rs.success) {
          if (isSaveDraft) {
            this.toastr.success(this.message.getMessage('messages.save_draft_success'));
            this.isFormChanging = false;
            this.router.navigate(['/home-enterprise/search-my-created-document/'], {
              queryParams: {}
            });
          } else {
            this.startSignFlow(rs.data);
          }
        } else if(rs.code == ErrorCode.MaxSizeError){
          this.maxSize = rs.data > 0 ? rs.data : this.size10MB;
        }
      });
    }
  }
  startSignFlow(id) {
    this.documentService.sendStartSignFlow(id).subscribe(res => {
      if (res) {
        this.toastr.success(this.message.getMessage('messages.save_draft_start_signing_success'));
        this.isFormChanging = false;
        this.router.navigate(['/home-enterprise/search-my-created-document/'], {
          queryParams: {}
        });
      }
    });
  }
  /**
   * Check code document duplicate
   * @param rs data after request api
   */
   private documentCodeDuplicateHanlder(rs: any) {
    if (!rs.success) {
      if (String(rs.code) === '0x001703') {
        this.createContractService.isDuplicateCode.next(true);
        const dialogRef = this.dialog.open(WarningComponent, {
          width: '30%',
          data: this.message.getMessage('validation.document_code_duplicate')
        });
        dialogRef.afterClosed().subscribe(rs => {
          if (rs) {
            this.dialog.closeAll();
            this.focusCode();
            localStorage.setItem('forcusCode','true');
          }
        });
      } else if (String(rs.code) === '0x002015') {
        this.toastr.error(this.message.getMessage('messages.warning_out_of_contract_quantity'));
      } else if (String(rs.code) === '0x004209') {
        this.toastr.error(this.message.getMessage('messages.contract_not_exist'));
      } else if (String(rs.code) === '0x002309') {
        this.toastr.error(this.message.getMessage('messages.is_not_auto_contract'));
        this.createContractService.isOnAutoNumber.next(false)
      }else if(rs.code == ErrorCode.MaxSizeError){
        this.notificationService.notify(Utils.toErrorMessage(rs, this.message.getMessage('messages.error_message')));
        this.maxSize = rs.data > 0 ? rs.data : this.size10MB;
      }
      else if(String(rs.code) === ErrorCode.Account_Subscribe_File_Download_Capacity_resource) {
        this.toastr.error(this.message.getMessage('messages.account_Subscribe_File_Download_Capacity_resource'));
      } else if(String(rs.code) === ErrorCode.Account_No_Subscribe_File_Download_Capacity_resource) {
        this.toastr.error(this.message.getMessage('messages.account_No_Subscribe_File_Download_Capacity_resource'));
      } else if(String(rs.code) === ErrorCode.EXPIRED_CONTRACT_1MB) {
        this.toastr.error(rs.message);
      } else if(String(rs.code) === ErrorCode.DUPLICATE_CUSTOMER || String(rs.code) === ErrorCode.QUICKLY_CONTRACT_PERMISSION) {
        this.toastr.error(rs.message);
      } else if(String(rs.code) == ErrorCode.OUT_OF_RESOURCES_10MB){
        this.toastr.error(rs.message)
      }
      else {
        // this.notificationService.notify(Utils.toErrorMessage(rs, this.message.getMessage('messages.error_message')));
        this.toastr.error(this.message.getMessage('messages.error_message'));
      }
    }
  }
  sortOrderUserSign(recordUserSign: any) {
    let newOrder = 0;
    let RECORD_USER_APPROVE = [...recordUserSign.filter(item => item.role === '2')];
    let RECORD_USER_SIGN = [...recordUserSign.filter(item => item.role === '1')];

    if(RECORD_USER_APPROVE.length) {
      RECORD_USER_APPROVE.sort((a, b) => {
        return a.order - b.order;
      });

      RECORD_USER_APPROVE = RECORD_USER_APPROVE.map((item, index) => {
        if(index === 0) {
          newOrder = 1;
          return {
            ...item,
            order: 1
          }
        } else {
          if(item.order !== RECORD_USER_APPROVE[index -1].order) {
            newOrder++;
          }
          return {
            ...item,
            order: newOrder
          }
        }
      });

      RECORD_USER_SIGN = RECORD_USER_SIGN.map((item) => ({
        ...item,
        order: RECORD_USER_APPROVE[RECORD_USER_APPROVE.length - 1].order + 1
      }))
    }

    return RECORD_USER_APPROVE.concat(RECORD_USER_SIGN);
  }
  drop(event: CdkDragDrop<string[]>) {
      this.setFormChanging();
      const filesSrc = this.fileUploadSrc;
      let arraySrcBeforeMoveFile = [...[]];
      let arraySrcAfterMoveFile = [...[]];
      let arraySrcFinal = [...[]];

      this.mainContractAttachments.forEach((data, indexFileName) => {
        filesSrc.forEach((fileSrc, indexFileSrc) => {
          if(indexFileName === indexFileSrc) {
            arraySrcBeforeMoveFile.push({
              src: fileSrc,
              fileName: data.fileName
            });
          }
        })
      });

      const checkIndexFile = !!(this.activeFile === event.previousIndex);
      const activeFileOld = this.activeFile;

      moveItemInArray(this.mainContractAttachments, event.previousIndex, event.currentIndex);
      if(this.activeFile === event.previousIndex) {
        this.activeFile = event.currentIndex;
      } else if(event.previousIndex > this.activeFile && event.currentIndex <= this.activeFile) {
        this.activeFile = this.activeFile + 1;
      } else if(event.previousIndex < this.activeFile && event.currentIndex >= this.activeFile) {
        this.activeFile = this.activeFile - 1;
      } else {
        // console.log(this.fileUploadArray)
      }
      this.mainContractAttachments = [...this.mainContractAttachments.map((file, index) => ({
        ...file,
        attachmentOrder: index
      }))];
      this.mainContractAttachments.forEach((data) => {
        arraySrcBeforeMoveFile.forEach((fileSrc) => {
          if(data.fileName === fileSrc.fileName) {
            arraySrcAfterMoveFile.push(fileSrc.src);
            arraySrcFinal.push({
              id: data.fileName,
              src: fileSrc.src
            });
          }
        })
      });
      let newFileArrayUpload: File[] = [];
      this.fileUploadSrc = arraySrcAfterMoveFile;
      arraySrcFinal.forEach((src) => {
        this.fileUploadArray.forEach(file => {
          if (file.name === src.id) {
            newFileArrayUpload.push(file);
          }
        })
      })
      this.fileUploadArray = newFileArrayUpload;
      for (let i=1; i <= this.maxPageCurrent; i++) {
        // console.log(`text-pdf-layer-${i}-${checkIndexFile ? event.previousIndex : this.activeFile}`)
        const element: any = document.getElementById(`text-pdf-layer-${i}-${checkIndexFile ? event.previousIndex : activeFileOld}`);
        if (element) {
          element.setAttribute('id', `text-pdf-layer-${i}-${this.activeFile}`);
        }
      }
      this.pdfSrc = arraySrcAfterMoveFile[this.activeFile];
      this.changeDataToTable()
      setTimeout(() => {
        const tabs = document.getElementsByClassName('tab');
        if (tabs) {
          Array.from({ length: tabs.length }, (v, i) => i).forEach(index => {
            const tab = tabs.item(index) as HTMLElement;
            tab.style.width = 100 / this.fileUploadArray.length + '%';
          })
        }
      }, 0);
    }
    onChangeCertificateNo(data:any){}

  get isInvalidSetPartyFlow(): boolean {
    const customerSigns = this.enterprises.value;
    return this.enterpriseSign.length === 0 && customerSigns.length === 0;
  }
  get isNoSigner(): boolean {
    const userSign = this.userSigns.find(user => user.role == '1');
    return !userSign && this.clickSave && this.enterpriseSign.length > 0;
  }

  focusCode() {
    setTimeout(() => {
      const inputElement = document.getElementById('code')
      if (inputElement) {
        inputElement.focus();
      }
      this.documentCodeDuplicate(1);
    }, 0);
  }
  public documentCodeDuplicate(rs: any): void {
    if (this.ngForm.form.controls.code) {
      this.ngForm.form.controls.code.setErrors({ duplicate: true });
      this.ngForm.form.controls.code.markAsTouched();
      document.getElementById('code').focus();
    }
  }
}
